import {
  Business,
  BusinessSearchNonEditablesEnum,
} from 'src/app/types/Business';
import { BusinessActivity } from 'src/app/types/BusinessActivity';
import { BusinessRegistrationType } from 'src/app/types/BusinessRegistrationType';
import { BusinessSummary } from 'src/app/types/BusinessSummary';
import { Country } from 'src/app/types/Country';
import { FlowSteps } from 'src/app/types/FlowSteps';
import { Invoice } from 'src/app/types/Invoice';
import { InvoiceActivity } from 'src/app/types/InvoiceActivity';
import { InvoiceStatus } from 'src/app/types/InvoiceStatus';
import { InvoiceTopLevelNumbers } from 'src/app/types/InvoiceTopLevelNumbers';
import { Profile } from 'src/app/types/Profile';
import { Role } from 'src/app/types/Role';
import { State } from 'src/app/types/States';
import { Step } from 'src/app/types/Step';
import { TopLevelNumbers } from 'src/app/types/TopLevelNumbers';
import { UserProfile } from 'src/app/types/UserProfile';
import { Customer } from 'src/app/types/invoiceCutomer';
import { InvoiceLog } from 'src/app/types/invoiceLog';
import { invoiceTopLevelAmountAndCount } from 'src/app/types/invoiceTopLevelAmountAndCount';
import { AffiliateVendor } from '../../../types/AffiliateVendor';
import { AuthorizedOfficer } from '../../../types/AuthorizedOfficer';
import { DayWisePayoutSummary } from '../../../types/DayWisePayoutSummary';
import { Deposit } from '../../../types/Deposit';
import { Payout } from '../../../types/Payout';
import { PayoutFrequencyPreferences } from '../../../types/PayoutsListingData';
import { BusinessOnboardingResponse } from '../../../types/responses/BusinessOnboardingResponse';
import { PayoutFeesResponse } from '../../../types/responses/PayoutFeesResponse';

export const mockCountries: Country[] = [
  { id: '1', name: 'United States', code: 'US' },
  { id: '2', name: 'India', code: 'IN' },
  { id: '3', name: 'Canada', code: 'CA' },
];

export const mockClientCountries: Country[] = [
  {
    id: '5',
    name: 'Albania',
    code: 'AL',
  },
  {
    id: '45',
    name: 'Algeria',
    code: 'DZ',
  },
  {
    id: '1',
    name: 'Andorra',
    code: 'AD',
  },
  {
    id: '7',
    name: 'Angola',
    code: 'AO',
  },
  {
    id: '4',
    name: 'Anguilla',
    code: 'AI',
  },
  {
    id: '3',
    name: 'Antigua and Barbuda',
    code: 'AG',
  },
  {
    id: '8',
    name: 'Argentina',
    code: 'AR',
  },
  {
    id: '6',
    name: 'Armenia',
    code: 'AM',
  },
  {
    id: '11',
    name: 'Aruba',
    code: 'AW',
  },
  {
    id: '10',
    name: 'Australia',
    code: 'AU',
  },
  {
    id: '9',
    name: 'Austria',
    code: 'AT',
  },
  {
    id: '12',
    name: 'Azerbaijan',
    code: 'AZ',
  },
  {
    id: '25',
    name: 'Bahamas',
    code: 'BS',
  },
  {
    id: '18',
    name: 'Bahrain',
    code: 'BH',
  },
  {
    id: '14',
    name: 'Barbados',
    code: 'BB',
  },
  {
    id: '15',
    name: 'Belgium',
    code: 'BE',
  },
  {
    id: '27',
    name: 'Belize',
    code: 'BZ',
  },
  {
    id: '20',
    name: 'Benin',
    code: 'BJ',
  },
  {
    id: '21',
    name: 'Bermuda',
    code: 'BM',
  },
  {
    id: '23',
    name: 'Bolivia (Plurinational State of)',
    code: 'BO',
  },
  {
    id: '13',
    name: 'Bosnia and Herzegovina',
    code: 'BA',
  },
  {
    id: '26',
    name: 'Botswana',
    code: 'BW',
  },
  {
    id: '24',
    name: 'Brazil',
    code: 'BR',
  },
  {
    id: '22',
    name: 'Brunei Darussalam',
    code: 'BN',
  },
  {
    id: '17',
    name: 'Bulgaria',
    code: 'BG',
  },
  {
    id: '16',
    name: 'Burkina Faso',
    code: 'BF',
  },
  {
    id: '19',
    name: 'Burundi',
    code: 'BI',
  },
  {
    id: '37',
    name: 'Cabo Verde',
    code: 'CV',
  },
  {
    id: '86',
    name: 'Cambodia',
    code: 'KH',
  },
  {
    id: '33',
    name: 'Cameroon',
    code: 'CM',
  },
  {
    id: '28',
    name: 'Canada',
    code: 'CA',
  },
  {
    id: '90',
    name: 'Cayman Islands',
    code: 'KY',
  },
  {
    id: '143',
    name: 'Chad',
    code: 'TD',
  },
  {
    id: '32',
    name: 'Chile',
    code: 'CL',
  },
  {
    id: '34',
    name: 'China',
    code: 'CN',
  },
  {
    id: '35',
    name: 'Colombia',
    code: 'CO',
  },
  {
    id: '29',
    name: 'Congo',
    code: 'CG',
  },
  {
    id: '36',
    name: 'Costa Rica',
    code: 'CR',
  },
  {
    id: '73',
    name: 'Croatia',
    code: 'HR',
  },
  {
    id: '38',
    name: 'Cyprus',
    code: 'CY',
  },
  {
    id: '39',
    name: 'Czech Republic',
    code: 'CZ',
  },
  {
    id: '31',
    name: 'Côte d Ivoire',
    code: 'CI',
  },
  {
    id: '42',
    name: 'Denmark',
    code: 'DK',
  },
  {
    id: '41',
    name: 'Djibouti',
    code: 'DJ',
  },
  {
    id: '43',
    name: 'Dominica',
    code: 'DM',
  },
  {
    id: '44',
    name: 'Dominican Republic',
    code: 'DO',
  },
  {
    id: '46',
    name: 'Ecuador',
    code: 'EC',
  },
  {
    id: '48',
    name: 'Egypt',
    code: 'EG',
  },
  {
    id: '66',
    name: 'Equatorial Guinea',
    code: 'GQ',
  },
  {
    id: '49',
    name: 'Eritrea',
    code: 'ER',
  },
  {
    id: '47',
    name: 'Estonia',
    code: 'EE',
  },
  {
    id: '142',
    name: 'Eswatini',
    code: 'SZ',
  },
  {
    id: '53',
    name: 'Falkland Islands (Malvinas)',
    code: 'FK',
  },
  {
    id: '54',
    name: 'Faroe Islands',
    code: 'FO',
  },
  {
    id: '52',
    name: 'Fiji',
    code: 'FJ',
  },
  {
    id: '51',
    name: 'Finland',
    code: 'FI',
  },
  {
    id: '55',
    name: 'France',
    code: 'FR',
  },
  {
    id: '60',
    name: 'French Guiana',
    code: 'GF',
  },
  {
    id: '122',
    name: 'French Polynesia',
    code: 'PF',
  },
  {
    id: '56',
    name: 'Gabon',
    code: 'GA',
  },
  {
    id: '64',
    name: 'Gambia',
    code: 'GM',
  },
  {
    id: '59',
    name: 'Georgia',
    code: 'GE',
  },
  {
    id: '40',
    name: 'Germany',
    code: 'DE',
  },
  {
    id: '61',
    name: 'Ghana',
    code: 'GH',
  },
  {
    id: '62',
    name: 'Gibraltar',
    code: 'GI',
  },
  {
    id: '67',
    name: 'Greece',
    code: 'GR',
  },
  {
    id: '63',
    name: 'Greenland',
    code: 'GL',
  },
  {
    id: '58',
    name: 'Grenada',
    code: 'GD',
  },
  {
    id: '65',
    name: 'Guadeloupe',
    code: 'GP',
  },
  {
    id: '69',
    name: 'Guam',
    code: 'GU',
  },
  {
    id: '68',
    name: 'Guatemala',
    code: 'GT',
  },
  {
    id: '160',
    name: 'Guinea',
    code: 'GN',
  },
  {
    id: '70',
    name: 'Guinea-Bissau',
    code: 'GW',
  },
  {
    id: '74',
    name: 'Haiti',
    code: 'HT',
  },
  {
    id: '72',
    name: 'Honduras',
    code: 'HN',
  },
  {
    id: '71',
    name: 'Hong Kong',
    code: 'HK',
  },
  {
    id: '75',
    name: 'Hungary',
    code: 'HU',
  },
  {
    id: '80',
    name: 'Iceland',
    code: 'IS',
  },
  {
    id: '76',
    name: 'Indonesia',
    code: 'ID',
  },
  {
    id: '77',
    name: 'Ireland',
    code: 'IE',
  },
  {
    id: '79',
    name: 'Israel',
    code: 'IL',
  },
  {
    id: '81',
    name: 'Italy',
    code: 'IT',
  },
  {
    id: '161',
    name: 'Jamaica',
    code: 'JM',
  },
  {
    id: '83',
    name: 'Japan',
    code: 'JP',
  },
  {
    id: '82',
    name: 'Jordan',
    code: 'JO',
  },
  {
    id: '91',
    name: 'Kazakhstan',
    code: 'KZ',
  },
  {
    id: '84',
    name: 'Kenya',
    code: 'KE',
  },
  {
    id: '87',
    name: 'Kiribati',
    code: 'KI',
  },
  {
    id: '89',
    name: 'Kuwait',
    code: 'KW',
  },
  {
    id: '85',
    name: 'Kyrgyzstan',
    code: 'KG',
  },
  {
    id: '92',
    name: "Lao People's Democratic Republic",
    code: 'LA',
  },
  {
    id: '98',
    name: 'Latvia',
    code: 'LV',
  },
  {
    id: '95',
    name: 'Lesotho',
    code: 'LS',
  },
  {
    id: '94',
    name: 'Liberia',
    code: 'LR',
  },
  {
    id: '93',
    name: 'Liechtenstein',
    code: 'LI',
  },
  {
    id: '96',
    name: 'Lithuania',
    code: 'LT',
  },
  {
    id: '97',
    name: 'Luxembourg',
    code: 'LU',
  },
  {
    id: '105',
    name: 'Macao',
    code: 'MO',
  },
  {
    id: '103',
    name: 'Madagascar',
    code: 'MG',
  },
  {
    id: '109',
    name: 'Malawi',
    code: 'MW',
  },
  {
    id: '111',
    name: 'Malaysia',
    code: 'MY',
  },
  {
    id: '107',
    name: 'Malta',
    code: 'MT',
  },
  {
    id: '106',
    name: 'Mauritania',
    code: 'MR',
  },
  {
    id: '108',
    name: 'Mauritius',
    code: 'MU',
  },
  {
    id: '110',
    name: 'Mexico',
    code: 'MX',
  },
  {
    id: '101',
    name: 'Moldova',
    code: 'MD',
  },
  {
    id: '100',
    name: 'Monaco',
    code: 'MC',
  },
  {
    id: '104',
    name: 'Mongolia',
    code: 'MN',
  },
  {
    id: '102',
    name: 'Montenegro',
    code: 'ME',
  },
  {
    id: '99',
    name: 'Morocco',
    code: 'MA',
  },
  {
    id: '112',
    name: 'Mozambique',
    code: 'MZ',
  },
  {
    id: '113',
    name: 'Namibia',
    code: 'NA',
  },
  {
    id: '116',
    name: 'Netherlands',
    code: 'NL',
  },
  {
    id: '118',
    name: 'New Zealand',
    code: 'NZ',
  },
  {
    id: '114',
    name: 'Niger',
    code: 'NE',
  },
  {
    id: '115',
    name: 'Nigeria',
    code: 'NG',
  },
  {
    id: '117',
    name: 'Norway',
    code: 'NO',
  },
  {
    id: '119',
    name: 'Oman',
    code: 'OM',
  },
  {
    id: '127',
    name: 'Palestine',
    code: 'PS',
  },
  {
    id: '120',
    name: 'Panama',
    code: 'PA',
  },
  {
    id: '123',
    name: 'Papua New Guinea',
    code: 'PG',
  },
  {
    id: '129',
    name: 'Paraguay',
    code: 'PY',
  },
  {
    id: '121',
    name: 'Peru',
    code: 'PE',
  },
  {
    id: '124',
    name: 'Philippines',
    code: 'PH',
  },
  {
    id: '125',
    name: 'Poland',
    code: 'PL',
  },
  {
    id: '128',
    name: 'Portugal',
    code: 'PT',
  },
  {
    id: '126',
    name: 'Puerto Rico',
    code: 'PR',
  },
  {
    id: '130',
    name: 'Qatar',
    code: 'QA',
  },
  {
    id: '88',
    name: 'Republic of Korea',
    code: 'KR',
  },
  {
    id: '132',
    name: 'Romania',
    code: 'RO',
  },
  {
    id: '131',
    name: 'R\u00e9union',
    code: 'RE',
  },
  {
    id: '162',
    name: 'Saint Kitts and Nevis',
    code: 'KN',
  },
  {
    id: '163',
    name: 'Saint Vincent and the Grenadines',
    code: 'VC',
  },
  {
    id: '140',
    name: 'San Marino',
    code: 'SM',
  },
  {
    id: '134',
    name: 'Saudi Arabia',
    code: 'SA',
  },
  {
    id: '141',
    name: 'Senegal',
    code: 'SN',
  },
  {
    id: '133',
    name: 'Serbia',
    code: 'RS',
  },
  {
    id: '164',
    name: 'Seychelles',
    code: 'SC',
  },
  {
    id: '139',
    name: 'Sierra Leone',
    code: 'SL',
  },
  {
    id: '136',
    name: 'Singapore',
    code: 'SG',
  },
  {
    id: '138',
    name: 'Slovakia',
    code: 'SK',
  },
  {
    id: '137',
    name: 'Slovenia',
    code: 'SI',
  },
  {
    id: '159',
    name: 'South Africa',
    code: 'ZA',
  },
  {
    id: '50',
    name: 'Spain',
    code: 'ES',
  },
  {
    id: '135',
    name: 'Sweden',
    code: 'SE',
  },
  {
    id: '30',
    name: 'Switzerland',
    code: 'CH',
  },
  {
    id: '152',
    name: 'Taiwan',
    code: 'TW',
  },
  {
    id: '146',
    name: 'Tajikistan',
    code: 'TJ',
  },
  {
    id: '153',
    name: 'Tanzania',
    code: 'TZ',
  },
  {
    id: '145',
    name: 'Thailand',
    code: 'TH',
  },
  {
    id: '147',
    name: 'Timor-Leste',
    code: 'TL',
  },
  {
    id: '144',
    name: 'Togo',
    code: 'TG',
  },
  {
    id: '151',
    name: 'Trinidad and Tobago',
    code: 'TT',
  },
  {
    id: '149',
    name: 'Tunisia',
    code: 'TN',
  },
  {
    id: '150',
    name: 'Turkey',
    code: 'TR',
  },
  {
    id: '148',
    name: 'Turkmenistan',
    code: 'TM',
  },
  {
    id: '154',
    name: 'Uganda',
    code: 'UG',
  },
  {
    id: '2',
    name: 'United Arab Emirates',
    code: 'AE',
  },
  {
    id: '57',
    name: 'United Kingdom',
    code: 'GB',
  },
  {
    id: '155',
    name: 'United States',
    code: 'US',
  },
  {
    id: '156',
    name: 'Uruguay',
    code: 'UY',
  },
  {
    id: '165',
    name: 'Uzbekistan',
    code: 'UZ',
  },
  {
    id: '158',
    name: 'Vanuatu',
    code: 'VU',
  },
  {
    id: '157',
    name: 'Vietnam',
    code: 'VN',
  },
  {
    id: '166',
    name: 'Virgin Islands (British)',
    code: 'VG',
  },
  {
    id: '167',
    name: 'Zambia',
    code: 'ZM',
  },
];

export const mockUSStates: State[] = [
  { id: '1', name: 'Alabama', code: 'Alabama' },
  { id: '2', name: 'Alaska', code: 'Alaska' },
  { id: '3', name: 'Arizona', code: 'Arizona' },
  { id: '4', name: 'Arkansas', code: 'Arkansas' },
  { id: '5', name: 'California', code: 'California' },
  { id: '6', name: 'Colorado', code: 'Colorado' },
  { id: '7', name: 'Connecticut', code: 'Connecticut' },
  { id: '8', name: 'Delaware', code: 'Delaware' },
  { id: '9', name: 'Florida', code: 'Florida' },
  { id: '10', name: 'Georgia', code: 'Georgia' },
  { id: '11', name: 'Hawaii', code: 'Hawaii' },
  { id: '12', name: 'Idaho', code: 'Idaho' },
  { id: '13', name: 'Illinois', code: 'Illinois' },
  { id: '14', name: 'Indiana', code: 'Indiana' },
  { id: '15', name: 'Iowa', code: 'Iowa' },
  { id: '16', name: 'Kansas', code: 'Kansas' },
  { id: '17', name: 'Kentucky', code: 'Kentucky' },
  { id: '18', name: 'Louisiana', code: 'Louisiana' },
  { id: '19', name: 'Maine', code: 'Maine' },
  { id: '20', name: 'Maryland', code: 'Maryland' },
  { id: '21', name: 'Massachusetts', code: 'Massachusetts' },
  { id: '22', name: 'Michigan', code: 'Michigan' },
  { id: '23', name: 'Minnesota', code: 'Minnesota' },
  { id: '24', name: 'Mississippi', code: 'Mississippi' },
  { id: '25', name: 'Missouri', code: 'Missouri' },
  { id: '26', name: 'Montana', code: 'Montana' },
  { id: '27', name: 'Nebraska', code: 'Nebraska' },
  { id: '28', name: 'Nevada', code: 'Nevada' },
  { id: '29', name: 'New Hampshire', code: 'NewHampshire' },
  { id: '30', name: 'New Jersey', code: 'NewJersey' },
  { id: '31', name: 'New Mexico', code: 'NewMexico' },
  { id: '32', name: 'New York', code: 'NewYork' },
  { id: '33', name: 'North Carolina', code: 'NorthCarolina' },
  { id: '34', name: 'North Dakota', code: 'NorthDakota' },
  { id: '35', name: 'Ohio', code: 'Ohio' },
  { id: '36', name: 'Oklahoma', code: 'Oklahoma' },
  { id: '37', name: 'Oregon', code: 'Oregon' },
  { id: '38', name: 'Pennsylvania', code: 'Pennsylvania' },
  { id: '39', name: 'Rhode Island', code: 'RhodeIsland' },
  { id: '40', name: 'South Carolina', code: 'SouthCarolina' },
  { id: '41', name: 'South Dakota', code: 'SouthDakota' },
  { id: '42', name: 'Tennessee', code: 'Tennessee' },
  { id: '43', name: 'Texas', code: 'Texas' },
  { id: '44', name: 'Utah', code: 'Utah' },
  { id: '45', name: 'Vermont', code: 'Vermont' },
  { id: '46', name: 'Virginia', code: 'Virginia' },
  { id: '47', name: 'Washington', code: 'Washington' },
  { id: '48', name: 'West Virginia', code: 'WestVirginia' },
  { id: '49', name: 'Wisconsin', code: 'Wisconsin' },
  { id: '50', name: 'Wyoming', code: 'Wyoming' },
];

export const mockBusinesses: Business[] = [
  {
    r2AId: '1',
    name: 'TechCorp',
    partnerId: 'CB001',
    PAN: 'ABCDE1234F',
    CIN: 'L01631KA2010PTC096843',
    nonEditables: [
      BusinessSearchNonEditablesEnum.name,
      BusinessSearchNonEditablesEnum.CIN,
      BusinessSearchNonEditablesEnum.PAN,
    ],
    country: mockCountries[0],
    address: {
      street: '123 Main St',
      city: 'San Francisco',
      state: 'CA',
      country: 'US',
      specificDetails: { stateCode: 'CA', zipCode: '94105' },
    },
    billingAddress: {
      street: '123 Main St',
      city: 'San Francisco',
      state: 'CA',
      country: 'US',
      specificDetails: { stateCode: 'CA', zipCode: '94105' },
    },
    businessRegistrationType: BusinessRegistrationType.PrivateLimitedCompany,
    businessActivity: BusinessActivity.TechnologyServices,
    directors: [
      {
        id: 'd1',
        name: 'Rokey Bhai',
        PAN: 'ABCDE1234F',
        roles: [Role.SrManager],
        isManual: true,
        // ubo: true,
        // srManager: false,
        // updateEnabled: true
      },
      {
        id: 'd2',
        name: 'Pushpa Raj',
        PAN: 'WXYZ9876K',
        roles: [Role.UBO],
        isManual: true,
        // ubo: true,
        // srManager: false,
        // updateEnabled: true
      },
      {
        id: 'd3',
        name: 'Rokey Bhai1',
        PAN: 'SDEFH1234F',
        roles: [Role.SrManager],
        isManual: false,
        // ubo: true,
        // srManager: false,
        // updateEnabled: true
      },
      {
        id: 'd4',
        name: 'Rokey Bhai2',
        PAN: 'GHTJK1234F',
        roles: [Role.SrManager],
        isManual: false,
        // ubo: true,
        // srManager: false,
        // updateEnabled: true
      },
    ],
    federalEIN: '11-1111111',
    dateEstablished: '2020-12-31T15:53:16',
    authorizedOfficer: {
      name: 'Ramesh',
      designation: 'CEO',
    } as AuthorizedOfficer,
    websiteUrl: 'https://techcorp.com',
    avgInvoiceSizeInInr: 500000,
    avgNoOfInvoicesPerMonth: 10,
    contactPerson: 'Krish',
    emailAddress: 'abc@gmail.com',
    vendorName: 'Ramesh',
    requestedDate: '04-9-2024',
    //profileImagePath: 'assets/images/profile/user-2.jpg',
    completed: false,
    role: 'Admin',
    createdDate: '04-07-2024',
    active: 0,
    overdue: 0,
    partnerRelationshipStatus: 'approved',
    paid: 18,
    currentBalance: {
      value: 13955.79,
      currency: 'USD',
    },
    phoneNumber: '+1 1111 1111',
    bankDetails: [
      {
        id: '1',
        paymentMethodType: 'ACH',
        accountName: 'John Doe',
        accountNumber: '123456789',
        achRouting: '987654321',
        accountType: 'Savings',
        bankName: 'Bank of America',
        bankAddress: '123 Finance St, NY',
        ifscCode: 'HDFC0000291',
      },
      {
        id: '2',
        paymentMethodType: 'RTP',
        accountName: 'John Doe',
        accountNumber: '123456789',
        achRouting: '987654321',
        accountType: 'Savings',
        bankName: 'Bank of America',
        bankAddress: '123 Finance St, NY',
        ifscCode: 'HDFC0000291',
      },
      {
        id: '3',
        paymentMethodType: 'FEDWIRE',
        accountName: 'John Doe',
        accountNumber: '123456789',
        achRouting: '987654321',
        accountType: 'Savings',
        bankName: 'Bank of America',
        bankAddress: '123 Finance St, NY',
        ifscCode: 'HDFC0000291',
      },
      {
        id: '4',
        paymentMethodType: 'SWIFT',
        accountName: 'John Doe',
        accountNumber: '123456789',
        achRouting: '987654321',
        accountType: 'Savings',
        bankName: 'Bank of America',
        bankAddress: '123 Finance St, NY',
        ifscCode: 'HDFC0000291',
      },
    ],
  },
  {
    r2AId: '2',
    name: 'IndTech',
    partnerId: 'CB002',
    country: mockCountries[1],
    PAN: 'ABCDE1234F',
    nonEditables: [
      BusinessSearchNonEditablesEnum.name,
      BusinessSearchNonEditablesEnum.PAN,
    ],
    address: {
      street: '456 Road',
      city: 'Tirupathi',
      state: 'Andhra Paresh',
      country: 'IN',
      specificDetails: { stateName: 'Tirupathi', pinCode: '400001' },
    },
    billingAddress: {
      street: '456 Road',
      city: 'Tirupathi',
      state: 'Andhra Paresh',
      country: 'IN',
      specificDetails: { stateName: 'Tirupathi', pinCode: '400001' },
    },
    businessRegistrationType: BusinessRegistrationType.PublicLimitedCompany,
    businessActivity: BusinessActivity.Manufacturing,
    directors: [
      {
        id: 'd1',
        name: 'Rokey Bhai',
        PAN: 'ABCDE1234F',
        roles: [Role.SrManager],
        isManual: true,
        // ubo: true,
        // srManager: false,
        //updateEnabled: true
      },
      {
        id: 'd2',
        name: 'Pushpa Raj',
        PAN: 'WXYZ9876K',
        roles: [Role.UBO],
        isManual: true,
        // ubo: true,
        // srManager: false,
        //updateEnabled: true
      },
      {
        id: 'd3',
        name: 'Rokey Bhai3',
        PAN: 'SDFGH1234T',
        roles: [Role.SrManager],
        isManual: false,
        // ubo: true,
        // srManager: false,
        // updateEnabled: true
      },
      {
        id: 'd4',
        name: 'Rokey Bhai4',
        PAN: 'GHTJK1234F',
        roles: [Role.SrManager],
        isManual: false,
        // ubo: true,
        // srManager: false,
        // updateEnabled: false
      },
    ],
    websiteUrl: 'https://indtech.in',
    avgInvoiceSizeInInr: 1000000,
    avgNoOfInvoicesPerMonth: 15,
    contactPerson: 'Santhi',
    emailAddress: 'santhi@gamil.com',
    vendorName: 'Madhu Kumar',
    requestedDate: '04-7-2024',
    profileImagePath: 'assets/images/profile/user-3.jpg',
    completed: false,
    role: 'Admin',
    createdDate: '04-05-2024',
    active: 60,
    overdue: 20,
    partnerRelationshipStatus: 'approved',
    paid: 15,
    currentBalance: {
      value: 0,
      currency: 'USD',
    },
    phoneNumber: '+1 1111 2222',
  },
  {
    r2AId: '3',
    name: 'Tesla',
    partnerId: 'CB003',
    country: mockCountries[1],
    PAN: 'ABCDE1234F',
    llpIN: 'LLPIN0123456',
    nonEditables: [
      BusinessSearchNonEditablesEnum.name,
      BusinessSearchNonEditablesEnum.PAN,
    ],
    address: {
      street: '456 Road',
      city: 'Ongole',
      state: 'Andhra Paresh',
      country: 'IN',
      specificDetails: { stateName: 'Ongole', pinCode: '400001' },
    },
    billingAddress: {
      street: '456 Road',
      city: 'Ongole',
      state: 'Andhra Paresh',
      country: 'IN',
      specificDetails: { stateName: 'Ongole', pinCode: '400001' },
    },
    businessRegistrationType: BusinessRegistrationType.PublicLimitedCompany,
    businessActivity: BusinessActivity.Manufacturing,
    directors: [
      {
        id: 'd2',
        name: 'Pushpa Raj',
        PAN: 'WXYZ9876K',
        roles: [Role.UBO],
      },
    ],
    websiteUrl: 'https://indtech.in',
    avgInvoiceSizeInInr: 1000000,
    avgNoOfInvoicesPerMonth: 15,
    contactPerson: 'Kumar',
    emailAddress: 'kumar12@gamil.com',
    vendorName: 'Rajesh',
    clientName: 'Kumar',
    requestedDate: '04-10-2024',
    profileImagePath: 'assets/images/profile/user-4.jpg',
    completed: false,
    role: 'Admin',
    createdDate: '04-07-2024',
    active: 35,
    overdue: 18,
    partnerRelationshipStatus: 'approved',
    paid: 17,
    currentBalance: {
      value: 17955.79,
      currency: 'USD',
    },
    phoneNumber: '+1 1111 3333',
  },
  {
    r2AId: '4',
    name: '',
    partnerId: '',
    PAN: 'ASOLE1234F',
    CIN: '',
    iecCode: '',
    noGSTOrIEC: '',
    nonEditables: [],
    authorizedOwnerName: 'Naveen Kandula',
    country: mockCountries[0],
    address: {
      street: '',
      city: '',
      state: '',
      country: '',
      specificDetails: { stateCode: 'CA', zipCode: '94105' },
    },
    billingAddress: {
      street: 'Vadlapudi',
      city: 'San Francisco',
      state: 'Andhara Pardesh',
      country: 'IN',
      specificDetails: { stateCode: 'CA', zipCode: '94105' },
    },
    businessRegistrationType: BusinessRegistrationType.PrivateLimitedCompany,
    businessActivity: BusinessActivity.TechnologyServices,
    directors: [],
    federalEIN: '',
    dateEstablished: '',
    authorizedOfficer: {
      name: 'Ramesh',
      designation: 'CEO',
    } as AuthorizedOfficer,
    websiteUrl: 'https://techcorp.com',
    avgInvoiceSizeInInr: 500000,
    avgNoOfInvoicesPerMonth: 10,
    contactPerson: 'Krish',
    emailAddress: 'abc@gmail.com',
    vendorName: 'Ramesh',
    requestedDate: '04-9-2024',
    //profileImagePath: 'assets/images/profile/user-2.jpg',
    completed: false,
    role: 'Admin',
    createdDate: '04-07-2024',
    active: 40,
    overdue: 25,
    partnerRelationshipStatus: 'approved',
    paid: 18,
    currentBalance: {
      value: 13955.79,
      currency: 'USD',
    },
    phoneNumber: '+1 1111 1111',
  },
  {
    r2AId: '1',
    name: 'TechCorp',
    partnerId: 'CB001',
    PAN: 'ABCDE1234F',
    CIN: 'L01631KA2010PTC096843',
    nonEditables: [
      BusinessSearchNonEditablesEnum.name,
      BusinessSearchNonEditablesEnum.CIN,
      BusinessSearchNonEditablesEnum.PAN,
    ],
    country: mockCountries[0],
    address: {
      street: '123 Main St',
      city: 'San Francisco',
      state: 'CA',
      country: 'US',
      specificDetails: { stateCode: 'CA', zipCode: '94105' },
    },
    billingAddress: {
      street: '123 Main St',
      city: 'San Francisco',
      state: 'CA',
      country: 'US',
      specificDetails: { stateCode: 'CA', zipCode: '94105' },
    },
    businessRegistrationType: BusinessRegistrationType.PrivateLimitedCompany,
    businessActivity: BusinessActivity.TechnologyServices,
    directors: [
      {
        id: 'd1',
        name: 'Rokey Bhai',
        PAN: 'ABCDE1234F',
        roles: [Role.SrManager],
        isManual: true,
        // ubo: true,
        // srManager: false,
        // updateEnabled: true
      },
      {
        id: 'd2',
        name: 'Pushpa Raj',
        PAN: 'WXYZ9876K',
        roles: [Role.UBO],
        isManual: true,
        // ubo: true,
        // srManager: false,
        // updateEnabled: true
      },
      {
        id: 'd3',
        name: 'Rokey Bhai1',
        PAN: 'SDEFH1234F',
        roles: [Role.SrManager],
        isManual: false,
        // ubo: true,
        // srManager: false,
        // updateEnabled: true
      },
      {
        id: 'd4',
        name: 'Rokey Bhai2',
        PAN: 'GHTJK1234F',
        roles: [Role.SrManager],
        isManual: false,
        // ubo: true,
        // srManager: false,
        // updateEnabled: true
      },
    ],
    federalEIN: '11-1111111',
    dateEstablished: '2020-12-31T15:53:16',
    authorizedOfficer: {
      name: 'Ramesh',
      designation: 'CEO',
    } as AuthorizedOfficer,
    websiteUrl: 'https://techcorp.com',
    avgInvoiceSizeInInr: 500000,
    avgNoOfInvoicesPerMonth: 10,
    contactPerson: 'Krish',
    emailAddress: 'abc@gmail.com',
    vendorName: 'Ramesh',
    requestedDate: '04-9-2024',
    //profileImagePath: 'assets/images/profile/user-2.jpg',
    completed: false,
    role: 'Admin',
    createdDate: '04-07-2024',
    active: 40,
    overdue: 25,
    partnerRelationshipStatus: 'approved',
    paid: 18,
    currentBalance: {
      value: 13955.79,
      currency: 'USD',
    },
    phoneNumber: '+1 1111 1111',
    bankDetails: [
      {
        id: '1',
        paymentMethodType: 'ACH',
        accountName: 'John Doe',
        accountNumber: '123456789',
        achRouting: '987654321',
        accountType: 'Savings',
        bankName: 'Bank of America',
        bankAddress: '123 Finance St, NY',
        ifscCode: 'HDFC0000291',
      },
      {
        id: '2',
        paymentMethodType: 'RTP',
        accountName: 'John Doe',
        accountNumber: '123456789',
        achRouting: '987654321',
        accountType: 'Savings',
        bankName: 'Bank of America',
        bankAddress: '123 Finance St, NY',
        ifscCode: 'HDFC0000291',
      },
      {
        id: '3',
        paymentMethodType: 'FEDWIRE',
        accountName: 'John Doe',
        accountNumber: '123456789',
        achRouting: '987654321',
        accountType: 'Savings',
        bankName: 'Bank of America',
        bankAddress: '123 Finance St, NY',
        ifscCode: 'HDFC0000291',
      },
      {
        id: '4',
        paymentMethodType: 'SWIFT',
        accountName: 'John Doe',
        accountNumber: '123456789',
        achRouting: '987654321',
        accountType: 'Savings',
        bankName: 'Bank of America',
        bankAddress: '123 Finance St, NY',
        ifscCode: 'HDFC0000291',
      },
    ],
  },
  {
    r2AId: '2',
    name: 'IndTech',
    partnerId: 'CB002',
    country: mockCountries[1],
    PAN: 'ABCDE1234F',
    nonEditables: [
      BusinessSearchNonEditablesEnum.name,
      BusinessSearchNonEditablesEnum.PAN,
    ],
    address: {
      street: '456 Road',
      city: 'Tirupathi',
      state: 'Andhra Paresh',
      country: 'IN',
      specificDetails: { stateName: 'Tirupathi', pinCode: '400001' },
    },
    billingAddress: {
      street: '456 Road',
      city: 'Tirupathi',
      state: 'Andhra Paresh',
      country: 'IN',
      specificDetails: { stateName: 'Tirupathi', pinCode: '400001' },
    },
    businessRegistrationType: BusinessRegistrationType.PublicLimitedCompany,
    businessActivity: BusinessActivity.Manufacturing,
    directors: [
      {
        id: 'd1',
        name: 'Rokey Bhai',
        PAN: 'ABCDE1234F',
        roles: [Role.SrManager],
        isManual: true,
        // ubo: true,
        // srManager: false,
        //updateEnabled: true
      },
      {
        id: 'd2',
        name: 'Pushpa Raj',
        PAN: 'WXYZ9876K',
        roles: [Role.UBO],
        isManual: true,
        // ubo: true,
        // srManager: false,
        //updateEnabled: true
      },
      {
        id: 'd3',
        name: 'Rokey Bhai3',
        PAN: 'SDFGH1234T',
        roles: [Role.SrManager],
        isManual: false,
        // ubo: true,
        // srManager: false,
        // updateEnabled: true
      },
      {
        id: 'd4',
        name: 'Rokey Bhai4',
        PAN: 'GHTJK1234F',
        roles: [Role.SrManager],
        isManual: false,
        // ubo: true,
        // srManager: false,
        // updateEnabled: false
      },
    ],
    websiteUrl: 'https://indtech.in',
    avgInvoiceSizeInInr: 1000000,
    avgNoOfInvoicesPerMonth: 15,
    contactPerson: 'Santhi',
    emailAddress: 'santhi@gamil.com',
    vendorName: 'Madhu Kumar',
    requestedDate: '04-7-2024',
    profileImagePath: 'assets/images/profile/user-3.jpg',
    completed: false,
    role: 'Admin',
    createdDate: '04-05-2024',
    active: 60,
    overdue: 20,
    partnerRelationshipStatus: 'approved',
    paid: 15,
    currentBalance: {
      value: 15955.79,
      currency: 'USD',
    },
    phoneNumber: '+1 1111 2222',
  },
  {
    r2AId: '3',
    name: 'Tesla',
    partnerId: 'CB003',
    country: mockCountries[1],
    PAN: 'ABCDE1234F',
    llpIN: 'LLPIN0123456',
    nonEditables: [
      BusinessSearchNonEditablesEnum.name,
      BusinessSearchNonEditablesEnum.PAN,
    ],
    address: {
      street: '456 Road',
      city: 'Ongole',
      state: 'Andhra Paresh',
      country: 'IN',
      specificDetails: { stateName: 'Ongole', pinCode: '400001' },
    },
    billingAddress: {
      street: '456 Road',
      city: 'Ongole',
      state: 'Andhra Paresh',
      country: 'IN',
      specificDetails: { stateName: 'Ongole', pinCode: '400001' },
    },
    businessRegistrationType: BusinessRegistrationType.PublicLimitedCompany,
    businessActivity: BusinessActivity.Manufacturing,
    directors: [
      {
        id: 'd2',
        name: 'Pushpa Raj',
        PAN: 'WXYZ9876K',
        roles: [Role.UBO],
      },
    ],
    websiteUrl: 'https://indtech.in',
    avgInvoiceSizeInInr: 1000000,
    avgNoOfInvoicesPerMonth: 15,
    contactPerson: 'Kumar',
    emailAddress: 'kumar12@gamil.com',
    vendorName: 'Rajesh',
    clientName: 'Kumar',
    requestedDate: '04-10-2024',
    profileImagePath: 'assets/images/profile/user-4.jpg',
    completed: false,
    role: 'Admin',
    createdDate: '04-07-2024',
    active: 35,
    overdue: 18,
    partnerRelationshipStatus: 'approved',
    paid: 17,
    currentBalance: {
      value: 17955.79,
      currency: 'USD',
    },
    phoneNumber: '+1 1111 3333',
  },
  {
    r2AId: '4',
    name: '',
    partnerId: '',
    PAN: 'ASOLE1234F',
    CIN: '',
    iecCode: '',
    noGSTOrIEC: '',
    nonEditables: [],
    authorizedOwnerName: 'Naveen Kandula',
    country: mockCountries[0],
    address: {
      street: '',
      city: '',
      state: '',
      country: '',
      specificDetails: { stateCode: 'CA', zipCode: '94105' },
    },
    billingAddress: {
      street: 'Vadlapudi',
      city: 'San Francisco',
      state: 'Andhara Pardesh',
      country: 'IN',
      specificDetails: { stateCode: 'CA', zipCode: '94105' },
    },
    businessRegistrationType: BusinessRegistrationType.PrivateLimitedCompany,
    businessActivity: BusinessActivity.TechnologyServices,
    directors: [],
    federalEIN: '',
    dateEstablished: '',
    authorizedOfficer: {
      name: 'Ramesh',
      designation: 'CEO',
    } as AuthorizedOfficer,
    websiteUrl: 'https://techcorp.com',
    avgInvoiceSizeInInr: 500000,
    avgNoOfInvoicesPerMonth: 10,
    contactPerson: 'Krish',
    emailAddress: 'abc@gmail.com',
    vendorName: 'Ramesh',
    requestedDate: '04-9-2024',
    //profileImagePath: 'assets/images/profile/user-2.jpg',
    completed: false,
    role: 'Admin',
    createdDate: '04-07-2024',
    active: 40,
    overdue: 25,
    partnerRelationshipStatus: 'approved',
    paid: 18,
    currentBalance: {
      value: 13955.79,
      currency: 'USD',
    },
    phoneNumber: '+1 1111 1111',
  },
  {
    r2AId: '1',
    name: 'TechCorp',
    partnerId: 'CB001',
    PAN: 'ABCDE1234F',
    CIN: 'L01631KA2010PTC096843',
    nonEditables: [
      BusinessSearchNonEditablesEnum.name,
      BusinessSearchNonEditablesEnum.CIN,
      BusinessSearchNonEditablesEnum.PAN,
    ],
    country: mockCountries[0],
    address: {
      street: '123 Main St',
      city: 'San Francisco',
      state: 'CA',
      country: 'US',
      specificDetails: { stateCode: 'CA', zipCode: '94105' },
    },
    billingAddress: {
      street: '123 Main St',
      city: 'San Francisco',
      state: 'CA',
      country: 'US',
      specificDetails: { stateCode: 'CA', zipCode: '94105' },
    },
    businessRegistrationType: BusinessRegistrationType.PrivateLimitedCompany,
    businessActivity: BusinessActivity.TechnologyServices,
    directors: [
      {
        id: 'd1',
        name: 'Rokey Bhai',
        PAN: 'ABCDE1234F',
        roles: [Role.SrManager],
        isManual: true,
        // ubo: true,
        // srManager: false,
        // updateEnabled: true
      },
      {
        id: 'd2',
        name: 'Pushpa Raj',
        PAN: 'WXYZ9876K',
        roles: [Role.UBO],
        isManual: true,
        // ubo: true,
        // srManager: false,
        // updateEnabled: true
      },
      {
        id: 'd3',
        name: 'Rokey Bhai1',
        PAN: 'SDEFH1234F',
        roles: [Role.SrManager],
        isManual: false,
        // ubo: true,
        // srManager: false,
        // updateEnabled: true
      },
      {
        id: 'd4',
        name: 'Rokey Bhai2',
        PAN: 'GHTJK1234F',
        roles: [Role.SrManager],
        isManual: false,
        // ubo: true,
        // srManager: false,
        // updateEnabled: true
      },
    ],
    federalEIN: '11-1111111',
    dateEstablished: '2020-12-31T15:53:16',
    authorizedOfficer: {
      name: 'Ramesh',
      designation: 'CEO',
    } as AuthorizedOfficer,
    websiteUrl: 'https://techcorp.com',
    avgInvoiceSizeInInr: 500000,
    avgNoOfInvoicesPerMonth: 10,
    contactPerson: 'Krish',
    emailAddress: 'abc@gmail.com',
    vendorName: 'Ramesh',
    requestedDate: '04-9-2024',
    //profileImagePath: 'assets/images/profile/user-2.jpg',
    completed: false,
    role: 'Admin',
    createdDate: '04-07-2024',
    active: 40,
    overdue: 25,
    partnerRelationshipStatus: 'approved',
    paid: 18,
    currentBalance: {
      value: 13955.79,
      currency: 'USD',
    },
    phoneNumber: '+1 1111 1111',
    bankDetails: [
      {
        id: '1',
        paymentMethodType: 'ACH',
        accountName: 'John Doe',
        accountNumber: '123456789',
        achRouting: '987654321',
        accountType: 'Savings',
        bankName: 'Bank of America',
        bankAddress: '123 Finance St, NY',
        ifscCode: 'HDFC0000291',
      },
      {
        id: '2',
        paymentMethodType: 'RTP',
        accountName: 'John Doe',
        accountNumber: '123456789',
        achRouting: '987654321',
        accountType: 'Savings',
        bankName: 'Bank of America',
        bankAddress: '123 Finance St, NY',
        ifscCode: 'HDFC0000291',
      },
      {
        id: '3',
        paymentMethodType: 'FEDWIRE',
        accountName: 'John Doe',
        accountNumber: '123456789',
        achRouting: '987654321',
        accountType: 'Savings',
        bankName: 'Bank of America',
        bankAddress: '123 Finance St, NY',
        ifscCode: 'HDFC0000291',
      },
      {
        id: '4',
        paymentMethodType: 'SWIFT',
        accountName: 'John Doe',
        accountNumber: '123456789',
        achRouting: '987654321',
        accountType: 'Savings',
        bankName: 'Bank of America',
        bankAddress: '123 Finance St, NY',
        ifscCode: 'HDFC0000291',
      },
    ],
  },
  {
    r2AId: '2',
    name: 'IndTech',
    partnerId: 'CB002',
    country: mockCountries[1],
    PAN: 'ABCDE1234F',
    nonEditables: [
      BusinessSearchNonEditablesEnum.name,
      BusinessSearchNonEditablesEnum.PAN,
    ],
    address: {
      street: '456 Road',
      city: 'Tirupathi',
      state: 'Andhra Paresh',
      country: 'IN',
      specificDetails: { stateName: 'Tirupathi', pinCode: '400001' },
    },
    billingAddress: {
      street: '456 Road',
      city: 'Tirupathi',
      state: 'Andhra Paresh',
      country: 'IN',
      specificDetails: { stateName: 'Tirupathi', pinCode: '400001' },
    },
    businessRegistrationType: BusinessRegistrationType.PublicLimitedCompany,
    businessActivity: BusinessActivity.Manufacturing,
    directors: [
      {
        id: 'd1',
        name: 'Rokey Bhai',
        PAN: 'ABCDE1234F',
        roles: [Role.SrManager],
        isManual: true,
        // ubo: true,
        // srManager: false,
        //updateEnabled: true
      },
      {
        id: 'd2',
        name: 'Pushpa Raj',
        PAN: 'WXYZ9876K',
        roles: [Role.UBO],
        isManual: true,
        // ubo: true,
        // srManager: false,
        //updateEnabled: true
      },
      {
        id: 'd3',
        name: 'Rokey Bhai3',
        PAN: 'SDFGH1234T',
        roles: [Role.SrManager],
        isManual: false,
        // ubo: true,
        // srManager: false,
        // updateEnabled: true
      },
      {
        id: 'd4',
        name: 'Rokey Bhai4',
        PAN: 'GHTJK1234F',
        roles: [Role.SrManager],
        isManual: false,
        // ubo: true,
        // srManager: false,
        // updateEnabled: false
      },
    ],
    websiteUrl: 'https://indtech.in',
    avgInvoiceSizeInInr: 1000000,
    avgNoOfInvoicesPerMonth: 15,
    contactPerson: 'Santhi',
    emailAddress: 'santhi@gamil.com',
    vendorName: 'Madhu Kumar',
    requestedDate: '04-7-2024',
    profileImagePath: 'assets/images/profile/user-3.jpg',
    completed: false,
    role: 'Admin',
    createdDate: '04-05-2024',
    active: 60,
    overdue: 20,
    partnerRelationshipStatus: 'approved',
    paid: 15,
    currentBalance: {
      value: 15955.79,
      currency: 'USD',
    },
    phoneNumber: '+1 1111 2222',
  },
  {
    r2AId: '3',
    name: 'Tesla',
    partnerId: 'CB003',
    country: mockCountries[1],
    PAN: 'ABCDE1234F',
    llpIN: 'LLPIN0123456',
    nonEditables: [
      BusinessSearchNonEditablesEnum.name,
      BusinessSearchNonEditablesEnum.PAN,
    ],
    address: {
      street: '456 Road',
      city: 'Ongole',
      state: 'Andhra Paresh',
      country: 'IN',
      specificDetails: { stateName: 'Ongole', pinCode: '400001' },
    },
    billingAddress: {
      street: '456 Road',
      city: 'Ongole',
      state: 'Andhra Paresh',
      country: 'IN',
      specificDetails: { stateName: 'Ongole', pinCode: '400001' },
    },
    businessRegistrationType: BusinessRegistrationType.PublicLimitedCompany,
    businessActivity: BusinessActivity.Manufacturing,
    directors: [
      {
        id: 'd2',
        name: 'Pushpa Raj',
        PAN: 'WXYZ9876K',
        roles: [Role.UBO],
      },
    ],
    websiteUrl: 'https://indtech.in',
    avgInvoiceSizeInInr: 1000000,
    avgNoOfInvoicesPerMonth: 15,
    contactPerson: 'Kumar',
    emailAddress: 'kumar12@gamil.com',
    vendorName: 'Rajesh',
    clientName: 'Kumar',
    requestedDate: '04-10-2024',
    profileImagePath: 'assets/images/profile/user-4.jpg',
    completed: false,
    role: 'Admin',
    createdDate: '04-07-2024',
    active: 35,
    overdue: 18,
    partnerRelationshipStatus: 'approved',
    paid: 17,
    currentBalance: {
      value: 17955.79,
      currency: 'USD',
    },
    phoneNumber: '+1 1111 3333',
  },
  {
    r2AId: '4',
    name: '',
    partnerId: '',
    PAN: 'ASOLE1234F',
    CIN: '',
    iecCode: '',
    noGSTOrIEC: '',
    nonEditables: [],
    authorizedOwnerName: 'Naveen Kandula',
    country: mockCountries[0],
    address: {
      street: '',
      city: '',
      state: '',
      country: '',
      specificDetails: { stateCode: 'CA', zipCode: '94105' },
    },
    billingAddress: {
      street: 'Vadlapudi',
      city: 'San Francisco',
      state: 'Andhara Pardesh',
      country: 'IN',
      specificDetails: { stateCode: 'CA', zipCode: '94105' },
    },
    businessRegistrationType: BusinessRegistrationType.PrivateLimitedCompany,
    businessActivity: BusinessActivity.TechnologyServices,
    directors: [],
    federalEIN: '',
    dateEstablished: '',
    authorizedOfficer: {
      name: 'Ramesh',
      designation: 'CEO',
    } as AuthorizedOfficer,
    websiteUrl: 'https://techcorp.com',
    avgInvoiceSizeInInr: 500000,
    avgNoOfInvoicesPerMonth: 10,
    contactPerson: 'Krish',
    emailAddress: 'abc@gmail.com',
    vendorName: 'Ramesh',
    requestedDate: '04-9-2024',
    //profileImagePath: 'assets/images/profile/user-2.jpg',
    completed: false,
    role: 'Admin',
    createdDate: '04-07-2024',
    active: 40,
    overdue: 25,
    partnerRelationshipStatus: 'approved',
    paid: 18,
    currentBalance: {
      value: 13955.79,
      currency: 'USD',
    },
    phoneNumber: '+1 1111 1111',
  },
  {
    r2AId: '1',
    name: 'TechCorp',
    partnerId: 'CB001',
    PAN: 'ABCDE1234F',
    CIN: 'L01631KA2010PTC096843',
    nonEditables: [
      BusinessSearchNonEditablesEnum.name,
      BusinessSearchNonEditablesEnum.CIN,
      BusinessSearchNonEditablesEnum.PAN,
    ],
    country: mockCountries[0],
    address: {
      street: '123 Main St',
      city: 'San Francisco',
      state: 'CA',
      country: 'US',
      specificDetails: { stateCode: 'CA', zipCode: '94105' },
    },
    billingAddress: {
      street: '123 Main St',
      city: 'San Francisco',
      state: 'CA',
      country: 'US',
      specificDetails: { stateCode: 'CA', zipCode: '94105' },
    },
    businessRegistrationType: BusinessRegistrationType.PrivateLimitedCompany,
    businessActivity: BusinessActivity.TechnologyServices,
    directors: [
      {
        id: 'd1',
        name: 'Rokey Bhai',
        PAN: 'ABCDE1234F',
        roles: [Role.SrManager],
        isManual: true,
        // ubo: true,
        // srManager: false,
        // updateEnabled: true
      },
      {
        id: 'd2',
        name: 'Pushpa Raj',
        PAN: 'WXYZ9876K',
        roles: [Role.UBO],
        isManual: true,
        // ubo: true,
        // srManager: false,
        // updateEnabled: true
      },
      {
        id: 'd3',
        name: 'Rokey Bhai1',
        PAN: 'SDEFH1234F',
        roles: [Role.SrManager],
        isManual: false,
        // ubo: true,
        // srManager: false,
        // updateEnabled: true
      },
      {
        id: 'd4',
        name: 'Rokey Bhai2',
        PAN: 'GHTJK1234F',
        roles: [Role.SrManager],
        isManual: false,
        // ubo: true,
        // srManager: false,
        // updateEnabled: true
      },
    ],
    federalEIN: '11-1111111',
    dateEstablished: '2020-12-31T15:53:16',
    authorizedOfficer: {
      name: 'Ramesh',
      designation: 'CEO',
    } as AuthorizedOfficer,
    websiteUrl: 'https://techcorp.com',
    avgInvoiceSizeInInr: 500000,
    avgNoOfInvoicesPerMonth: 10,
    contactPerson: 'Krish',
    emailAddress: 'abc@gmail.com',
    vendorName: 'Ramesh',
    requestedDate: '04-9-2024',
    //profileImagePath: 'assets/images/profile/user-2.jpg',
    completed: false,
    role: 'Admin',
    createdDate: '04-07-2024',
    active: 40,
    overdue: 25,
    partnerRelationshipStatus: 'approved',
    paid: 18,
    currentBalance: {
      value: 13955.79,
      currency: 'USD',
    },
    phoneNumber: '+1 1111 1111',
    bankDetails: [
      {
        id: '1',
        paymentMethodType: 'ACH',
        accountName: 'John Doe',
        accountNumber: '123456789',
        achRouting: '987654321',
        accountType: 'Savings',
        bankName: 'Bank of America',
        bankAddress: '123 Finance St, NY',
        ifscCode: 'HDFC0000291',
      },
      {
        id: '2',
        paymentMethodType: 'RTP',
        accountName: 'John Doe',
        accountNumber: '123456789',
        achRouting: '987654321',
        accountType: 'Savings',
        bankName: 'Bank of America',
        bankAddress: '123 Finance St, NY',
        ifscCode: 'HDFC0000291',
      },
      {
        id: '3',
        paymentMethodType: 'FEDWIRE',
        accountName: 'John Doe',
        accountNumber: '123456789',
        achRouting: '987654321',
        accountType: 'Savings',
        bankName: 'Bank of America',
        bankAddress: '123 Finance St, NY',
        ifscCode: 'HDFC0000291',
      },
      {
        id: '4',
        paymentMethodType: 'SWIFT',
        accountName: 'John Doe',
        accountNumber: '123456789',
        achRouting: '987654321',
        accountType: 'Savings',
        bankName: 'Bank of America',
        bankAddress: '123 Finance St, NY',
        ifscCode: 'HDFC0000291',
      },
    ],
  },
  {
    r2AId: '2',
    name: 'IndTech',
    partnerId: 'CB002',
    country: mockCountries[1],
    PAN: 'ABCDE1234F',
    nonEditables: [
      BusinessSearchNonEditablesEnum.name,
      BusinessSearchNonEditablesEnum.PAN,
    ],
    address: {
      street: '456 Road',
      city: 'Tirupathi',
      state: 'Andhra Paresh',
      country: 'IN',
      specificDetails: { stateName: 'Tirupathi', pinCode: '400001' },
    },
    billingAddress: {
      street: '456 Road',
      city: 'Tirupathi',
      state: 'Andhra Paresh',
      country: 'IN',
      specificDetails: { stateName: 'Tirupathi', pinCode: '400001' },
    },
    businessRegistrationType: BusinessRegistrationType.PublicLimitedCompany,
    businessActivity: BusinessActivity.Manufacturing,
    directors: [
      {
        id: 'd1',
        name: 'Rokey Bhai',
        PAN: 'ABCDE1234F',
        roles: [Role.SrManager],
        isManual: true,
        // ubo: true,
        // srManager: false,
        //updateEnabled: true
      },
      {
        id: 'd2',
        name: 'Pushpa Raj',
        PAN: 'WXYZ9876K',
        roles: [Role.UBO],
        isManual: true,
        // ubo: true,
        // srManager: false,
        //updateEnabled: true
      },
      {
        id: 'd3',
        name: 'Rokey Bhai3',
        PAN: 'SDFGH1234T',
        roles: [Role.SrManager],
        isManual: false,
        // ubo: true,
        // srManager: false,
        // updateEnabled: true
      },
      {
        id: 'd4',
        name: 'Rokey Bhai4',
        PAN: 'GHTJK1234F',
        roles: [Role.SrManager],
        isManual: false,
        // ubo: true,
        // srManager: false,
        // updateEnabled: false
      },
    ],
    websiteUrl: 'https://indtech.in',
    avgInvoiceSizeInInr: 1000000,
    avgNoOfInvoicesPerMonth: 15,
    contactPerson: 'Santhi',
    emailAddress: 'santhi@gamil.com',
    vendorName: 'Madhu Kumar',
    requestedDate: '04-7-2024',
    profileImagePath: 'assets/images/profile/user-3.jpg',
    completed: false,
    role: 'Admin',
    createdDate: '04-05-2024',
    active: 60,
    overdue: 20,
    partnerRelationshipStatus: 'approved',
    paid: 15,
    currentBalance: {
      value: 15955.79,
      currency: 'USD',
    },
    phoneNumber: '+1 1111 2222',
  },
  {
    r2AId: '3',
    name: 'Tesla',
    partnerId: 'CB003',
    country: mockCountries[1],
    PAN: 'ABCDE1234F',
    llpIN: 'LLPIN0123456',
    nonEditables: [
      BusinessSearchNonEditablesEnum.name,
      BusinessSearchNonEditablesEnum.PAN,
    ],
    address: {
      street: '456 Road',
      city: 'Ongole',
      state: 'Andhra Paresh',
      country: 'IN',
      specificDetails: { stateName: 'Ongole', pinCode: '400001' },
    },
    billingAddress: {
      street: '456 Road',
      city: 'Ongole',
      state: 'Andhra Paresh',
      country: 'IN',
      specificDetails: { stateName: 'Ongole', pinCode: '400001' },
    },
    businessRegistrationType: BusinessRegistrationType.PublicLimitedCompany,
    businessActivity: BusinessActivity.Manufacturing,
    directors: [
      {
        id: 'd2',
        name: 'Pushpa Raj',
        PAN: 'WXYZ9876K',
        roles: [Role.UBO],
      },
    ],
    websiteUrl: 'https://indtech.in',
    avgInvoiceSizeInInr: 1000000,
    avgNoOfInvoicesPerMonth: 15,
    contactPerson: 'Kumar',
    emailAddress: 'kumar12@gamil.com',
    vendorName: 'Rajesh',
    clientName: 'Kumar',
    requestedDate: '04-10-2024',
    profileImagePath: 'assets/images/profile/user-4.jpg',
    completed: false,
    role: 'Admin',
    createdDate: '04-07-2024',
    active: 35,
    overdue: 18,
    partnerRelationshipStatus: 'approved',
    paid: 17,
    currentBalance: {
      value: 17955.79,
      currency: 'USD',
    },
    phoneNumber: '+1 1111 3333',
  },
  {
    r2AId: '4',
    name: '',
    partnerId: '',
    PAN: 'ASOLE1234F',
    CIN: '',
    iecCode: '',
    noGSTOrIEC: '',
    nonEditables: [],
    authorizedOwnerName: 'Naveen Kandula',
    country: mockCountries[0],
    address: {
      street: '',
      city: '',
      state: '',
      country: '',
      specificDetails: { stateCode: 'CA', zipCode: '94105' },
    },
    billingAddress: {
      street: 'Vadlapudi',
      city: 'San Francisco',
      state: 'Andhara Pardesh',
      country: 'IN',
      specificDetails: { stateCode: 'CA', zipCode: '94105' },
    },
    businessRegistrationType: BusinessRegistrationType.PrivateLimitedCompany,
    businessActivity: BusinessActivity.TechnologyServices,
    directors: [],
    federalEIN: '',
    dateEstablished: '',
    authorizedOfficer: {
      name: 'Ramesh',
      designation: 'CEO',
    } as AuthorizedOfficer,
    websiteUrl: 'https://techcorp.com',
    avgInvoiceSizeInInr: 500000,
    avgNoOfInvoicesPerMonth: 10,
    contactPerson: 'Krish',
    emailAddress: 'abc@gmail.com',
    vendorName: 'Ramesh',
    requestedDate: '04-9-2024',
    //profileImagePath: 'assets/images/profile/user-2.jpg',
    completed: false,
    role: 'Admin',
    createdDate: '04-07-2024',
    active: 40,
    overdue: 25,
    partnerRelationshipStatus: 'approved',
    paid: 18,
    currentBalance: {
      value: 13955.79,
      currency: 'USD',
    },
    phoneNumber: '+1 1111 1111',
  },
];

export const selectbusinessStep: Step = {
  stepId: 'select_business',
  state: 'completed',
  action: 'required',
  details: {
    description: '',
    autoPopulated: false,
  },
};

export const directorSelectionStep: Step = {
  stepId: 'director_selection',
  state: 'pending',
  action: 'required',
  details: {
    description: '',
    directors: [
      {
        id: 'd1',
        name: 'Rokey Bhai',
        PAN: 'ABCDE1234F',
        roles: [Role.SrManager],
      },
      {
        id: 'd2',
        name: 'Pushpa Raj',
        PAN: 'WXYZ9876K',
        roles: [Role.UBO],
      },
    ],
  },
};

export const bankAccountDetails: Step = {
  stepId: 'bank_account_details_info_collection',
  state: 'pending',
  action: 'required',
  details: {},
};

export const businessComplianceCheckStep: Step = {
  stepId: 'business_compliance_check',
  state: 'pending',
  action: 'required',
  details: { responseLine1: 'yes', responseLine2: 'no' },
};

export const businessActivityValidationStep: Step = {
  stepId: 'business_activity_validation',
  state: 'pending',
  action: 'required',
  details: { description: '' },
};

export const additionalInfoCollectionStep: Step = {
  stepId: 'additional_info_collection',
  state: 'pending',
  action: 'required',
  details: { description: '' },
};

export const mockVendorOnboardingFlowSteps: FlowSteps = {
  steps: [
    selectbusinessStep,
    { ...directorSelectionStep, state: 'completed' },
    bankAccountDetails,
    businessActivityValidationStep,
    additionalInfoCollectionStep,
    businessComplianceCheckStep,
  ],
};

export const mockVendorOnboardingFlowStepsAfterSuccessfulBusinessActivitySelection: FlowSteps =
  {
    steps: [
      { ...businessActivityValidationStep, state: 'completed' },
      selectbusinessStep,
      directorSelectionStep,
      bankAccountDetails,
      additionalInfoCollectionStep,
      businessComplianceCheckStep,
    ],
  };

export const mockVendorOnboardingFlowStepsAfterDirectorSelection: FlowSteps = {
  steps: [
    selectbusinessStep,
    { ...businessActivityValidationStep, state: 'completed' },
    { ...directorSelectionStep, state: 'completed' },
    bankAccountDetails,
    additionalInfoCollectionStep,
    businessComplianceCheckStep,
  ],
};

export const mockVendorOnboardingFlowStepsAfterBankAccountSelectionSuccess: FlowSteps =
  {
    steps: [
      selectbusinessStep,
      { ...businessActivityValidationStep, state: 'completed' },
      { ...directorSelectionStep, state: 'completed' },
      { ...bankAccountDetails, state: 'completed' },
      additionalInfoCollectionStep,
      businessComplianceCheckStep,
    ],
  };

export const mockVendorOnboardingFlowStepsAfterBankAccountSelectionFailure: FlowSteps =
  {
    steps: [
      selectbusinessStep,
      { ...directorSelectionStep, state: 'completed' },
      {
        ...bankAccountDetails,
        state: 'pending',
        details: {
          errors: [
            {
              type: 'account_name_mismatch',
              message:
                "Bank Account Name doesn't match with the Company Account Name.",
            },
          ],
        },
      },
      businessActivityValidationStep,
      additionalInfoCollectionStep,
      businessComplianceCheckStep,
    ],
  };

export const mockVendorOnboardingFlowStepsAfterBusinessActivityValidation: FlowSteps =
  {
    steps: [
      selectbusinessStep,
      { ...directorSelectionStep, state: 'completed' },
      { ...businessActivityValidationStep, state: 'completed' },
      additionalInfoCollectionStep,
      businessComplianceCheckStep,
    ],
  };

export const mockVendorOnboardingFlowStepsAfterBusinessComplianceCheck: FlowSteps =
  {
    steps: [
      selectbusinessStep,
      { ...directorSelectionStep, state: 'completed' },
      { ...businessActivityValidationStep, state: 'completed' },
      { ...businessComplianceCheckStep, state: 'completed' },
      additionalInfoCollectionStep,
    ],
  };

export const mockVendorOnboardingFlowStepsAfterAdditonalInfoSelection: FlowSteps =
  {
    steps: [
      selectbusinessStep,
      { ...directorSelectionStep, state: 'completed' },
      { ...businessActivityValidationStep, state: 'completed' },
      { ...additionalInfoCollectionStep, state: 'completed' },
      businessComplianceCheckStep,
    ],
  };

const mockTimeline: InvoiceActivity[] = [
  {
    aType: 'INVOICE_CREATED',
    aTitle: 'Invoice Created',
    aDate: new Date('2025-01-01T10:00:00Z'),
    aAnnotation: 'Invoice created! Invoice no - INV-001 for $3,000 USD',
  },
  {
    aType: 'INVOICE_UPDATED',
    aTitle: 'Invoice Updated',
    aDate: new Date('2025-01-01T11:00:00Z'),
    aAnnotation: 'Invoice details updated. Invoice no - INV-001 for $5,000 USD',
  },
  {
    aType: 'INVOICE_PUBLISHED',
    aTitle: 'Invoice Published',
    aDate: new Date('2025-01-01T12:00:00Z'),
    aAnnotation:
      'Invoice INV-001 for $5,000 was published. Requested for the verification with provider.',
  },
  {
    aType: 'INVOICE_VERIFIED',
    aTitle: 'Invoice Verified',
    aDate: new Date('2025-01-01T13:00:00Z'),
    aAnnotation:
      'Invoice INV-001 has been verified and now active for payment.',
  },
  {
    aType: 'INVOICE_UNPAID',
    aTitle: 'Unpaid',
    aDate: new Date('2025-01-01T14:00:00Z'),
    aAnnotation:
      'Invoice #INV-001 for $5,000 is unpaid. Awaiting Wallet Credit',
  },
  // {
  //   aType: 'REMINDER_SENT',
  //   aTitle: 'Reminder Sent',
  //   aDate: new Date('2025-01-01T15:00:00Z'),
  //   aAnnotation: 'A payment reminder #1 has been sent for invoice #INV-001',
  // },
  {
    aType: 'INVOICE_PARTIALLY_PAID',
    aTitle: 'Partial Payment Received',
    aDate: new Date('2025-01-01T16:00:00Z'),
    aAnnotation:
      'Client Has made a partial payment for $3,000 towards invoice #INV-001. Remaining balance $2,000.',
  },
  {
    aType: 'INVOICE_PAID',
    aTitle: 'Invoice Paid',
    aDate: new Date('2025-01-01T17:00:00Z'),
    aAnnotation: 'Invoice INV-001 for $5,000, has been paid.',
  },
  {
    aType: 'WITHDRAWAL_INITIATED',
    aTitle: 'Withdrawal Initiated',
    aDate: new Date('2025-01-01T18:00:00Z'),
    aAnnotation:
      'A withdrawal request for $500 from Invoice #1234 has been initiated.',
  },
  {
    aType: 'WITHDRAWAL_SETTLED',
    aTitle: 'Payout Settled',
    aDate: new Date('2025-01-01T19:00:00Z'),
    aAnnotation:
      'The payment of $500 from Invoice #1234 has been successfully settled',
  },
  {
    aType: 'FIRA_GENERATED',
    aTitle: 'FIRC Generated',
    aDate: new Date('2025-01-01T20:00:00Z'),
    aAnnotation:
      'The Foreign Inward Remittance Certificate (FIRC) for Invoice #1234 is now available for download.',
  },
];

export const mockInvoiceLog: InvoiceLog = {
  invoiceNo: 'INV-001',
  companyName: 'Tesla Inc',
  name: 'Prinyansh Jain',
  emailAddress: 'priyanshjain2015@tesla.com',
  phoneNumber: '123-456-7890',
  address: 'Tesla Headquarters, California, USA',
  businessActivity: BusinessActivity.Manufacturing,
  invitationSentDate: '2024-07-01',
  issueDate: '2024-06-04',
  dueDate: '2024-10-22',
  amount: {
    value: 2000,
    currency: 'USD',
  },
  timeline: mockTimeline,
};

export const mockInvoices: Invoice[] = [
  {
    id: '1',
    clientBusinessId: '1',
    partnerId: 'CB001',
    billingStartDateUTC: '2024-06-01T00:00:00Z',
    billingEndDateUTC: '2024-06-30T23:59:59Z',
    invoiceDate: '2024-07-01',
    dueDate: '2024-07-15',
    vatPercentage: 0.75,
    vat: 100,
    purposeCode: 'P80081',
    subTotal: 1500,
    totalAmount: { value: 1000, currency: 'USD' },
    dueAmount: { value: 500, currency: 'USD' },
    status: InvoiceStatus.Unpaid,
    invoiceItems: [
      {
        id: '1',
        itemDescription: 'Consulting Services',
        quantity: 10,
        price: { value: 100, currency: 'USD' },
        total: 1000,
        tax: 10,
      },
    ],
    vendorBusinessId: 'VB001',
    invoiceNo: 'INV-001',
    purposeOfTransaction: 'Monthly IT Consulting',
    requestedPaymentBankDetails: [
      {
        id: '1',
        paymentMethodType: 'ACH',
        accountName: 'TechCorp Account',
        accountNumber: '123456789',
        achRouting: '987654321',
        accountType: 'Savings',
        bankName: 'Bank of America',
        bankAddress: '123 Finance St, NY',
        ifscCode: 'HDFC0000291',
      },
    ],
    isValid: false,
    billTo: 'Nagajuna Malempati(Nag)',
    billFrom: 'Pineapple Inc.',
    profilePath: '/assets/images/profile/nag.png',
    uploadedInvoice: {
      name: 'test.pdf',
      url: 'https://mozilla.github.io/pdf.js/web/compressed.tracemonkey-pldi-09.pdf',
    },
    transactionType: 'services',
    invoiceLog: mockInvoiceLog,
    partnerCurrentBalance: { value: 1000, currency: 'USD' },
  },
  {
    id: '2',
    clientBusinessId: 'CB002',
    partnerId: 'CB002',
    billingStartDateUTC: '2024-06-01T00:00:00Z',
    billingEndDateUTC: '2024-06-30T23:59:59Z',
    invoiceDate: '2024-07-02',
    vat: 100,
    purposeCode: 'P80081',
    subTotal: 1500,
    dueDate: '2024-07-20',
    totalAmount: { value: 2000, currency: 'USD' },
    dueAmount: { value: 500, currency: 'USD' },
    status: InvoiceStatus.Paid,
    invoiceItems: [
      {
        id: '2',
        itemDescription: 'Software License',
        quantity: 5,
        price: { value: 400, currency: 'USD' },
        total: 2000,
        tax: 5,
      },
    ],
    vendorBusinessId: 'VB002',
    invoiceNo: 'INV-002',
    purposeOfTransaction: 'Annual SaaS License',
    requestedPaymentBankDetails: [
      {
        id: '1',
        paymentMethodType: 'ACH',
        accountName: 'IndTech Account',
        accountNumber: '987654321',
        achRouting: '123456789',
        accountType: 'Savings',
        bankName: 'HDFC Bank',
        bankAddress: '456 Finance Rd, Mumbai',
        ifscCode: 'HDFC0000291',
      },
    ],
    isValid: false,
    profilePath: '/assets/images/svgs/tesla.svg',
    billFrom: 'Incorporation.',
    billTo: 'Tesla Inc',
    transactionType: 'goods',
    invoiceLog: mockInvoiceLog,
  },
  {
    id: '3',
    clientBusinessId: 'CB003',
    partnerId: 'CB003',
    billingStartDateUTC: '2024-06-01T00:00:00Z',
    billingEndDateUTC: '2024-06-30T23:59:59Z',
    invoiceDate: '2024-07-02',
    dueDate: '2024-07-20',
    vat: 100,
    purposeCode: 'P80081',
    subTotal: 1500,
    totalAmount: { value: 2000, currency: 'USD' },
    dueAmount: { value: 500, currency: 'USD' },
    status: InvoiceStatus.Draft,
    invoiceItems: [
      {
        id: '2',
        itemDescription: 'Software License',
        quantity: 5,
        price: { value: 400, currency: 'USD' },
        total: 2000,
        tax: 5,
      },
    ],
    vendorBusinessId: 'VB002',
    invoiceNo: 'INV-003',
    purposeOfTransaction: 'Annual SaaS License',
    requestedPaymentBankDetails: [
      {
        id: '1',
        paymentMethodType: 'ACH',
        accountName: 'IndTech Account',
        accountNumber: '987654321',
        achRouting: '123456789',
        accountType: 'Savings',
        bankName: 'HDFC Bank',
        bankAddress: '456 Finance Rd, Mumbai',
        ifscCode: 'HDFC0000291',
      },
    ],
    isValid: false,
    profilePath: '/assets/images/svgs/tesla.svg',
    billFrom: 'Incorporation.',
    billTo: 'Amazon',
    transactionType: 'goods',
    invoiceLog: mockInvoiceLog,
  },
  {
    id: '4',
    clientBusinessId: 'CB004',
    billingStartDateUTC: '2024-06-01T00:00:00Z',
    billingEndDateUTC: '2024-06-30T23:59:59Z',
    invoiceDate: '2024-07-01',
    dueDate: '2024-07-15',
    vat: 100,
    purposeCode: 'P80081',
    subTotal: 1500,
    totalAmount: { value: 1000, currency: 'USD' },
    dueAmount: { value: 500, currency: 'USD' },
    status: InvoiceStatus.Overdue,
    invoiceItems: [
      {
        id: '1',
        itemDescription: 'Consulting Services',
        quantity: 10,
        price: { value: 100, currency: 'USD' },
        total: 1000,
        tax: 10,
      },
    ],
    vendorBusinessId: 'VB004',
    invoiceNo: 'INV-001',
    purposeOfTransaction: 'Monthly IT Consulting',
    requestedPaymentBankDetails: [
      {
        id: '1',
        paymentMethodType: 'ACH',
        accountName: 'TechCorp Account',
        accountNumber: '123456789',
        achRouting: '987654321',
        accountType: 'Savings',
        bankName: 'Bank of America',
        bankAddress: '123 Finance St, NY',
        ifscCode: 'HDFC0000291',
      },
    ],
    isValid: false,
    billTo: 'FaceBook',
    billFrom: 'PineApple Inc.',
    profilePath: '/assets/images/profile/nag.png',
    transactionType: 'software',
  },
  {
    id: '5',
    clientBusinessId: 'CB004',
    billingStartDateUTC: '2024-06-01T00:00:00Z',
    billingEndDateUTC: '2024-06-30T23:59:59Z',
    invoiceDate: '2024-07-01',
    dueDate: '2024-07-15',
    vat: 100,
    purposeCode: 'P80081',
    subTotal: 1500,
    totalAmount: { value: 1000, currency: 'USD' },
    dueAmount: { value: 500, currency: 'USD' },
    status: InvoiceStatus.PartialPaid,
    invoiceItems: [
      {
        id: '1',
        itemDescription: 'Consulting Services',
        quantity: 10,
        price: { value: 100, currency: 'USD' },
        total: 1000,
        tax: 10,
      },
    ],
    vendorBusinessId: 'VB004',
    invoiceNo: 'INV-001',
    purposeOfTransaction: 'Monthly IT Consulting',
    requestedPaymentBankDetails: [
      {
        id: '1',
        paymentMethodType: 'ACH',
        accountName: 'TechCorp Account',
        accountNumber: '123456789',
        achRouting: '987654321',
        accountType: 'Savings',
        bankName: 'Bank of America',
        bankAddress: '123 Finance St, NY',
        ifscCode: 'HDFC0000291',
      },
    ],
    isValid: false,
    billTo: 'FaceBook',
    billFrom: 'PineApple Inc.',
    profilePath: '/assets/images/profile/nag.png',
    transactionType: 'software',
    invoiceLog: mockInvoiceLog,
  },
];

export const mockPayoutFrequencyPreferencesDaily: PayoutFrequencyPreferences = {
  frequency: 'daily',
};

export const mockPayoutFrequencyPreferencesMonthly: PayoutFrequencyPreferences =
  {
    frequency: 'monthly',
    dayOfMonth: 15,
  };

export const mockPayoutFrequencyPreferencesWeekly: PayoutFrequencyPreferences =
  {
    frequency: 'weekly',
    dayOfWeek: 'monday',
  };

export const mockDayWisePayoutsSummary: DayWisePayoutSummary[] = [
  //Current Week (July 14, 2025)
  {
    date: '2025-07-14',
    totalAmount: 2000,
    totalPayouts: 2,
    payoutCurrency: 'INR',
  },
  {
    date: '2025-07-15',
    totalAmount: 4000,
    totalPayouts: 4,
    payoutCurrency: 'INR',
  },
  {
    date: '2025-07-16',
    totalAmount: 1000,
    totalPayouts: 1,
    payoutCurrency: 'INR',
  },
  {
    date: '2025-07-17',
    totalAmount: 500,
    totalPayouts: 1,
    payoutCurrency: 'INR',
  },
  {
    date: '2025-07-18',
    totalAmount: 3000,
    totalPayouts: 3,
    payoutCurrency: 'INR',
  },
  {
    date: '2025-07-19',
    totalAmount: 8000,
    totalPayouts: 8,
    payoutCurrency: 'INR',
  },

  //Last week (July 7, 2025)
  {
    date: '2025-07-07',
    totalAmount: 2000,
    totalPayouts: 2,
    payoutCurrency: 'INR',
  },
  {
    date: '2025-07-08',
    totalAmount: 4000,
    totalPayouts: 4,
    payoutCurrency: 'INR',
  },
  {
    date: '2025-07-09',
    totalAmount: 1000,
    totalPayouts: 1,
    payoutCurrency: 'INR',
  },
  {
    date: '2025-07-10',
    totalAmount: 500,
    totalPayouts: 1,
    payoutCurrency: 'INR',
  },
  {
    date: '2025-07-11',
    totalAmount: 3000,
    totalPayouts: 3,
    payoutCurrency: 'INR',
  },
  {
    date: '2025-07-12',
    totalAmount: 8000,
    totalPayouts: 8,
    payoutCurrency: 'INR',
  },

  // Current Month (July 2024) - multiple days, different amounts
  {
    date: '2024-07-01',
    totalAmount: 2000,
    totalPayouts: 2,
    payoutCurrency: 'INR',
  },
  {
    date: '2024-07-02',
    totalAmount: 4000,
    totalPayouts: 4,
    payoutCurrency: 'INR',
  },
  {
    date: '2024-07-03',
    totalAmount: 1000,
    totalPayouts: 1,
    payoutCurrency: 'INR',
  },
  {
    date: '2024-07-07',
    totalAmount: 500,
    totalPayouts: 1,
    payoutCurrency: 'INR',
  },
  {
    date: '2024-07-15',
    totalAmount: 3000,
    totalPayouts: 3,
    payoutCurrency: 'INR',
  },
  {
    date: '2024-07-31',
    totalAmount: 8000,
    totalPayouts: 8,
    payoutCurrency: 'INR',
  },

  // Previous Month (June 2024) - for last month filter
  {
    date: '2024-06-01',
    totalAmount: 1500,
    totalPayouts: 2,
    payoutCurrency: 'INR',
  },
  {
    date: '2024-06-15',
    totalAmount: 2500,
    totalPayouts: 2,
    payoutCurrency: 'INR',
  },
  {
    date: '2024-06-30',
    totalAmount: 3500,
    totalPayouts: 3,
    payoutCurrency: 'INR',
  },

  // Quarter boundary (Q2/Q3)
  {
    date: '2024-04-01',
    totalAmount: 10000,
    totalPayouts: 10,
    payoutCurrency: 'INR',
  },
  {
    date: '2024-09-30',
    totalAmount: 12000,
    totalPayouts: 12,
    payoutCurrency: 'INR',
  },

  // Financial year boundary (Indian FY: Apr-Mar)
  {
    date: '2024-03-31',
    totalAmount: 9000,
    totalPayouts: 9,
    payoutCurrency: 'INR',
  },
  {
    date: '2024-04-01',
    totalAmount: 11000,
    totalPayouts: 11,
    payoutCurrency: 'INR',
  },

  // Last Year (2023)
  {
    date: '2023-12-31',
    totalAmount: 5000,
    totalPayouts: 5,
    payoutCurrency: 'INR',
  },
  {
    date: '2023-04-01',
    totalAmount: 7000,
    totalPayouts: 7,
    payoutCurrency: 'INR',
  },

  // Next Year (2025) - future data
  {
    date: '2025-01-01',
    totalAmount: 6000,
    totalPayouts: 6,
    payoutCurrency: 'INR',
  },
  {
    date: '2025-03-31',
    totalAmount: 7500,
    totalPayouts: 7,
    payoutCurrency: 'INR',
  },
  {
    date: '2025-04-01',
    totalAmount: 8000,
    totalPayouts: 8,
    payoutCurrency: 'INR',
  },
  {
    date: '2025-07-01',
    totalAmount: 9000,
    totalPayouts: 9,
    payoutCurrency: 'INR',
  },

  // Edge cases
  {
    date: '2024-07-10',
    totalAmount: 0,
    totalPayouts: 0,
    payoutCurrency: 'INR',
  }, // zero payouts
  {
    date: '2024-07-11',
    totalAmount: 1,
    totalPayouts: 1,
    payoutCurrency: 'INR',
  }, // single payout, very low amount
  {
    date: '2024-07-12',
    totalAmount: 1000000,
    totalPayouts: 100,
    payoutCurrency: 'INR',
  }, // very high amount

  // Week boundary (Sunday/Monday)
  {
    date: '2024-07-07',
    totalAmount: 500,
    totalPayouts: 1,
    payoutCurrency: 'INR',
  }, // Sunday
  {
    date: '2024-07-08',
    totalAmount: 600,
    totalPayouts: 2,
    payoutCurrency: 'INR',
  }, // Monday

  // Duplicates for filter robustness
  {
    date: '2024-07-01',
    totalAmount: 3000,
    totalPayouts: 3,
    payoutCurrency: 'INR',
  },
];

export const mockPayouts: Payout[] = [
  {
    id: 'payout1',
    businessId: '1',
    clientBusinessId: '2',
    partnerId: 'CB001',
    invoiceId: '121212',
    sentDateUTC: '2025-01-29T00:00:00Z',
    expectedReceiveDateUTC: '2025-01-31T00:00:00Z',
    payoutReferenceId: 'referencefromexternal1',

    grossPayoutAmount: 23.5,
    netPayoutAmount: 22.5,
    grossOrNetPayoutCurrency: 'USD',

    finalSettledAmount: 2034.86,
    finalSettledCurrency: 'INR',

    bankAccountNumber: '123456789',

    payoutFee: 9.0,
    payoutAmount: 17234.56,

    payoutStatus: 'initialized',
    receiptFileId: undefined,
  },
  {
    id: 'payout2',
    businessId: '1',
    clientBusinessId: '3',
    partnerId: '2',
    invoiceId: '121213',
    sentDateUTC: '2024-12-29T00:00:00Z',
    expectedReceiveDateUTC: '2024-12-31T00:00:00Z',
    payoutReferenceId: 'referencefromexternal2',

    grossPayoutAmount: 22.5,
    netPayoutAmount: 21.5,
    grossOrNetPayoutCurrency: 'USD',

    finalSettledAmount: 1934.86,
    finalSettledCurrency: 'INR',

    payoutStatus: 'settled',
    receiptFileId: 'file_F0A_1739124843148_4tBJC_000',
  },
  {
    id: 'payout3',
    businessId: '1',
    clientBusinessId: '4',
    partnerId: '3',
    invoiceId: '121214',
    sentDateUTC: '2025-01-29T00:00:00Z',
    expectedReceiveDateUTC: '2025-01-31T00:00:00Z',
    payoutReferenceId: 'referencefromexternal3',

    grossPayoutAmount: 22.5,
    netPayoutAmount: 21.5,
    grossOrNetPayoutCurrency: 'USD',

    finalSettledAmount: 1934.86,
    finalSettledCurrency: 'INR',

    payoutStatus: 'processing',
    receiptFileId: undefined,
  },
  {
    id: 'payout4',
    businessId: '1',
    clientBusinessId: '4',
    partnerId: '3',
    invoiceId: '121214',
    sentDateUTC: '2025-01-21T00:00:00Z',
    expectedReceiveDateUTC: '2025-01-31T00:00:00Z',
    payoutReferenceId: 'referencefromexternal2',

    grossPayoutAmount: 22.5,
    netPayoutAmount: 21.5,
    grossOrNetPayoutCurrency: 'USD',

    finalSettledAmount: 1934.86,
    finalSettledCurrency: 'INR',

    payoutStatus: 'processing',
    receiptFileId: undefined,
  },
  {
    id: 'payout5',
    businessId: '1',
    clientBusinessId: '5',
    partnerId: '4',
    invoiceId: '121214',
    sentDateUTC: '2025-01-29T00:00:00Z',
    expectedReceiveDateUTC: '2025-02-01T00:00:00Z',
    payoutReferenceId: 'referencefromexternal3',

    grossPayoutAmount: 22.5,
    netPayoutAmount: 21.5,
    grossOrNetPayoutCurrency: 'USD',

    finalSettledAmount: 1934.86,
    finalSettledCurrency: 'INR',

    payoutStatus: 'failed',
    receiptFileId: undefined,
  },
  {
    id: 'payout6',
    businessId: '1',
    clientBusinessId: '3',
    partnerId: '2',
    invoiceId: '121214',
    sentDateUTC: '2025-01-21T00:00:00Z',
    expectedReceiveDateUTC: '2025-01-22T00:00:00Z',
    payoutReferenceId: 'referencefromexternal6',

    grossPayoutAmount: 22.5,
    netPayoutAmount: 21.5,
    grossOrNetPayoutCurrency: 'USD',

    finalSettledAmount: 1934.86,
    finalSettledCurrency: 'INR',

    payoutStatus: 'hold',
    receiptFileId: undefined,
  },
];

export const mockCustometrs: Customer[] = [
  {
    id: 'CB001',
    name: 'Nagajuna Malempati(Nag)',
    profile: '/assets/images/svgs/tesla.svg',
    phoneNumber: '123-456-7890',
    emailAddress: 'nagajuna2015@tesla.com',
  },
  {
    id: 'CB002',
    name: 'Tesla Inc',
    profile: '/assets/images/svgs/tesla.svg',
    phoneNumber: '123-456-5590',
    emailAddress: 'priyanshjain2016@tesla.com',
  },
  {
    id: 'CB003',
    name: 'Amazon',
    profile: '/assets/images/svgs/tesla.svg',
    phoneNumber: '123-456-8650',
    emailAddress: 'jhondoe2016@amazon.com',
  },
  {
    id: 'CB004',
    name: 'FaceBook',
    profile: '/assets/images/svgs/tesla.svg',
    phoneNumber: '123-456-7890',
    emailAddress: 'rohndoe2017@facebook.com',
  },
];

export const mockProfile: Profile = {
  businessId: 'r2A001',
  name: 'John Doe',
  emails: ['john.doe@example.com', 'rohn.doe@example.com'],
  phoneNumbers: ['123-456-7890'],
  businessRegistrationType: BusinessRegistrationType.LlpRegistration,
  //address : '123 Finance St, San Francisco, CA, US, 94105',
  address: {
    street: '123 Main',
    city: 'San Francisco',
    state: 'CA',
    country: 'US',
    specificDetails: { stateCode: 'CA', zipCode: '94105' },
  },
  paymentMethodDetails: [
    {
      id: '1',
      paymentMethodType: 'ACH',
      accountName: 'John Doe',
      accountNumber: '123456789',
      achRouting: '987654321',
      accountType: 'Savings',
      bankName: 'Bank of America',
      bankAddress: '123 Finance St, NY',
      ifscCode: 'HDFC0000291',
    },
  ],
  profilePicture: 'assets/images/profile/user-10.jpg', //'https://example.com/johndoe.jpg',
  connectedAccounts: 'priyanshjain2015@tesla.com',
  createdDate: '2024-06-30T23:59:59Z',
  accountNumber: '123***89',
  ifscCode: 'ICIC0003456',
};

export const mockUserProfile: UserProfile = {
  userId: 'u1002',
  status: 'active',
  name: 'Rajat Pancholi',
  email: 'abc@example.com',
  phoneNumber: '+91 7893367890',
  profilePicture: '',
  affiliateManager: true,
};

export const mockSecondProfile: Profile = {
  businessId: 'r2A002',
  name: 'Jane Dane',
  emails: ['john.dane@example.com', 'rohn.dane@example.com'],
  phoneNumbers: ['123-456-7890'],
  businessRegistrationType: BusinessRegistrationType.SoleProprietorship,
  //address : '123 Finance St, San Francisco, CA, US, 94105',
  address: {
    street: '123 Main',
    city: 'San Francisco',
    state: 'CA',
    country: 'US',
    specificDetails: { stateCode: 'CA', zipCode: '94105' },
  },
  paymentMethodDetails: [
    {
      id: '1',
      paymentMethodType: 'ACH',
      accountName: 'Jane Dane',
      accountNumber: '123456789',
      achRouting: '987654321',
      accountType: 'Savings',
      bankName: 'Bank of America',
      bankAddress: '123 Finance St, NY',
      ifscCode: 'HDFC0000291',
    },
  ],
  profilePicture: 'assets/images/profile/user-10.jpg', //'https://example.com/johndoe.jpg',
  connectedAccounts: 'priyanshjain2015@tesla.com',
  createdDate: '2024-06-30T23:59:59Z',
  accountNumber: '123***89',
  ifscCode: 'ICIC0003456',
};

export const mockPayoutFeesList: PayoutFeesResponse[] = [
  {
    payoutFeesPlanId: 'fee_plan_F0A_1666077553446_a8fQ1_001',
    grossAmountInSourceCurrency: 40,
    netAmountInSourceCurrency: 40,
    netAmountInDestinationCurrency: 16680,
    sourceCurrency: 'USD',
    destinationCurrency: 'INR',
    payoutFeesIsFixed: true,
    fixedPayoutFees: 0,
    totalPayoutFees: 0,
    variablePayoutFeesPercentage: 0,
    variablePayoutFeesMinimum: 0,
    variablePayoutFees: 0,
    conversionAgainstOneUnit: 83.4,
    estimatedPayoutDate: '2025-02-15T00:00:00Z',
  },
  {
    payoutFeesPlanId: 'fee_plan_F0A_1666077553446_a8fQ1_002',
    grossAmountInSourceCurrency: 50,
    netAmountInSourceCurrency: 30,
    netAmountInDestinationCurrency: 2442,
    sourceCurrency: 'USD',
    destinationCurrency: 'INR',
    payoutFeesIsFixed: true,
    fixedPayoutFees: 20,
    totalPayoutFees: 80,
    variablePayoutFeesPercentage: 20,
    variablePayoutFeesMinimum: 0,
    variablePayoutFees: 60,
    conversionAgainstOneUnit: 81.4,
    estimatedPayoutDate: '2025-02-15T00:00:00Z',
  },
  {
    payoutFeesPlanId: 'fee_plan_F0A_1666077553446_a8fQ1_000',
    grossAmountInSourceCurrency: 5000,
    netAmountInSourceCurrency: 5000,
    netAmountInDestinationCurrency: 498210.9,
    sourceCurrency: 'USD',
    destinationCurrency: 'INR',
    payoutFeesIsFixed: false,
    fixedPayoutFees: 10,
    totalPayoutFees: 50,
    variablePayoutFeesPercentage: 5,
    variablePayoutFeesMinimum: 0,
    variablePayoutFees: 40,
    conversionAgainstOneUnit: 85.4,
    estimatedPayoutDate: '2025-02-15T00:00:00Z',
  },
];

export const sent: invoiceTopLevelAmountAndCount = {
  amount: 35000,
  count: 5,
};
export const overdue: invoiceTopLevelAmountAndCount = {
  amount: 56000,
  count: 8,
};

export const paid: invoiceTopLevelAmountAndCount = {
  amount: 67000,
  count: 4,
};

export const invoicetTopLevelNumbers: InvoiceTopLevelNumbers = {
  sent: sent,
  overdue: overdue,
  paid: paid,
};

export const topLevelNumbers: TopLevelNumbers = {
  usdAccountBalance: 50000,
  totalInvoicesRaised: 150,
  totalRaisedInvoices: 100,
  totalDues: 20000,
  totalInvoicesDue: 20,
  totalRevenuesEarned: 300000,
  activeCustomers: 50,
  totalInvoicesRaisedCount: 10,
  totalDuesCount: 20,
  totalRevenuesEarnedCount: 20,
};

export const mockBusinessSummary: BusinessSummary = {
  businessSummary: mockBusinesses[0],
  topLevelNumbers: topLevelNumbers,
  businesses: mockBusinesses,
  myInvoiceGroups: [
    {
      topLevelNumbers: topLevelNumbers,
      groupName: 'All',
      invoices: mockInvoices,
    },
    {
      topLevelNumbers: topLevelNumbers,
      groupName: 'Active',
      invoices: mockInvoices,
    },
    {
      topLevelNumbers: topLevelNumbers,
      groupName: 'Draft',
      invoices: mockInvoices,
    },
  ],
};

export const kycOnboardingResponseFreshAfterFirstStep: BusinessOnboardingResponse =
  {
    onboardingStatus: 'pending',
    business: {
      r2AId: '',
      nonEditables: [],
      name: '',
      country: mockCountries[1],
      businessRegistrationType: BusinessRegistrationType.PrivateLimitedCompany,
      contactPerson: '',
      emailAddress: '',
      vendorName: '',
      requestedDate: '',
      profileImagePath: '',
      completed: false,
      role: '',
      createdDate: '',
    },
    flowSteps: {
      steps: [
        {
          stepId: 'select_business',
          state: 'completed',
          action: 'required',
          details: {
            description: '',
            autoPopulated: false,
          },
        },
        {
          details: {
            autoPopulated: false,
          },
          stepId: 'business_activity_validation',
          state: 'pending',
          action: 'required',
          errors: [],
        },
        {
          details: {},
          stepId: 'director_selection',
          state: 'pending',
          action: 'required',
          errors: [],
        },
        {
          details: {},
          stepId: 'business_compliance_check',
          state: 'pending',
          action: 'required',
          errors: [],
        },
        {
          details: {},
          stepId: 'bank_account_details_info_collection',
          state: 'pending',
          action: 'required',
          errors: [],
        },
        {
          details: {},
          stepId: 'additional_info_collection',
          state: 'pending',
          action: 'required',
          errors: [],
        },
      ],
    },
    context: 'new_business_onboarding',
    onboardingId: '498f9a3a-bc41-4004-b128-61dfd832c67a',
  };

// export const
export const kycOnboardingResponseAfterFirstStep: BusinessOnboardingResponse = {
  onboardingStatus: 'pending',
  business: {
    r2AId: '',
    name: '',
    nonEditables: [],
    country: mockCountries[1],
    address: {
      street: '',
      city: '',
      state: '',
      country: '',
      specificDetails: { pinCode: '', stateName: '' },
    },
    billingAddress: {
      street: '',
      city: '',
      state: '',
      country: '',
      specificDetails: { pinCode: '', stateName: '' },
    },
    businessRegistrationType: BusinessRegistrationType.PrivateLimitedCompany,
    contactPerson: '',
    emailAddress: '',
    vendorName: '',
    requestedDate: '',
    profileImagePath: '',
    completed: false,
    role: '',
    createdDate: '',
  },
  flowSteps: {
    steps: [
      {
        details: {},
        stepId: 'select_business',
        state: 'pending',
        action: 'required',
        errors: [],
      },
      {
        details: {},
        stepId: 'director_selection',
        state: 'pending',
        action: 'required',
        errors: [],
      },
      {
        details: {},
        stepId: 'business_compliance_check',
        state: 'pending',
        action: 'required',
        errors: [],
      },
      {
        details: {},
        stepId: 'bank_account_details_info_collection',
        state: 'pending',
        action: 'required',
        errors: [],
      },
      {
        details: {},
        stepId: 'additional_info_collection',
        state: 'pending',
        action: 'required',
        errors: [],
      },
    ],
  },
  context: 'new_business_onboarding',
  onboardingId: '7239e7ac-0d7e-476d-b5b2-e2fa47b37549',
};

export const kycOnboardingResponseAfterFirstStepContinueWithManualFillingOfBusinessDetails: BusinessOnboardingResponse =
  {
    onboardingStatus: 'pending',
    business: {
      name: 'qwerty',
      nonEditables: [BusinessSearchNonEditablesEnum.name],
      country: mockCountries[1],
      r2AId: '',
      address: {
        street: 'L01631KA2010PTC096843',
        city: 'L01631KA2010PTC096843',
        state: 'L01631KA2010PTC096843',
        country: 'IN',
        specificDetails: {
          stateName: 'L01631KA2010PTC096843',
          pinCode: 'L01631KA2010PTC096843',
        },
      },
      billingAddress: {
        street: 'L01631KA2010PTC096843',
        city: 'L01631KA2010PTC096843',
        state: 'L01631KA2010PTC096843',
        country: 'IN',
        specificDetails: {
          stateName: 'L01631KA2010PTC096843',
          pinCode: 'L01631KA2010PTC096843',
        },
      },
      businessActivity: BusinessActivity.GoodsExport,
      businessRegistrationType: BusinessRegistrationType.PrivateLimitedCompany,
      contactPerson: '',
      emailAddress: '',
      vendorName: '',
      requestedDate: '',
      profileImagePath: '',
      completed: false,
      role: '',
      createdDate: '',
    },
    flowSteps: {
      steps: [
        {
          details: {
            autoPopulated: false,
          },
          stepId: 'select_business',
          state: 'completed',
          action: 'required',
          errors: [],
        },
        {
          details: {},
          stepId: 'director_selection',
          state: 'pending',
          action: 'required',
          errors: [],
        },
        {
          details: {},
          stepId: 'business_compliance_check',
          state: 'pending',
          action: 'required',
          errors: [],
        },
        {
          details: {},
          stepId: 'bank_account_details_info_collection',
          state: 'pending',
          action: 'required',
          errors: [],
        },
        {
          details: {},
          stepId: 'additional_info_collection',
          state: 'pending',
          action: 'required',
          errors: [],
        },
      ],
    },
    context: 'new_business_onboarding',
    onboardingId: '7239e7ac-0d7e-476d-b5b2-e2fa47b37549',
  };

export const kycOnboardingResponseAfterFirstStepContinueWithPanSearchFillingOfBusinessDetails: BusinessOnboardingResponse =
  {
    onboardingStatus: 'pending',
    business: {
      r2AId: '',
      nonEditables: [BusinessSearchNonEditablesEnum.name],
      country: mockCountries[1],
      name: 'MOKSHAGNA TECHNOLOGIES PRIVATE LIMITED',
      address: {
        street:
          'D1303, Valmark Orchard Square, Kothnur, Main Road, Next to BMTC Depot JP Nagar',
        city: 'Bangalore',
        state: 'Karnataka',
        country: 'IN',
        specificDetails: {
          stateName: 'Karnataka',
          pinCode: '560076',
        },
      },
      billingAddress: {
        street:
          'D1303, Valmark Orchard Square, Kothnur, Main Road, Next to BMTC Depot JP Nagar',
        city: 'Bangalore',
        state: 'Karnataka',
        country: 'IN',
        specificDetails: {
          stateName: 'Karnataka',
          pinCode: '560076',
        },
      },
      businessActivity: BusinessActivity.GoodsExport,
      directors: [
        {
          name: 'RAGHU VAMSI GONNABATHULA',
          roles: [],
          id: '',
        },
        {
          name: 'AVINASH OGURI',
          roles: [],
          id: '',
        },
        {
          name: 'VENKATA RAMANA NAIDU MARADANA',
          roles: [],
          id: '',
        },
        {
          name: 'NAGARJUNA MALEMPATI',
          roles: [],
          id: '',
        },
      ],
      businessRegistrationType: BusinessRegistrationType.PrivateLimitedCompany,
      contactPerson: '',
      emailAddress: '',
      vendorName: '',
      requestedDate: '',
      profileImagePath: '',
      completed: false,
      role: '',
      createdDate: '',
    },
    flowSteps: {
      steps: [
        {
          details: {
            autoPopulated: true,
          },
          stepId: 'select_business',
          state: 'completed',
          action: 'required',
          errors: [],
        },
        {
          details: {},
          stepId: 'director_selection',
          state: 'pending',
          action: 'required',
          errors: [],
        },
        {
          details: {},
          stepId: 'business_compliance_check',
          state: 'pending',
          action: 'required',
          errors: [],
        },
        {
          details: {},
          stepId: 'bank_account_details_info_collection',
          state: 'pending',
          action: 'required',
          errors: [],
        },
        {
          details: {},
          stepId: 'additional_info_collection',
          state: 'pending',
          action: 'required',
          errors: [],
        },
      ],
    },
    context: 'new_business_onboarding',
    onboardingId: '7239e7ac-0d7e-476d-b5b2-e2fa47b37549',
  };

export const kycOnboardingResponseAfterFirstStepWithSuccessfulPanSearch: BusinessOnboardingResponse =
  {
    onboardingStatus: 'pending',
    business: {
      r2AId: '',
      country: mockCountries[1],
      nonEditables: [BusinessSearchNonEditablesEnum.name],
      name: 'MOKSHAGNA TECHNOLOGIES PRIVATE LIMITED',
      address: {
        street:
          'D1303, Valmark Orchard Square, Kothnur, Main Road, Next to BMTC Depot JP Nagar',
        city: 'Bangalore',
        state: 'Karnataka',
        country: 'IN',
        specificDetails: {
          stateName: 'Karnataka',
          pinCode: '560076',
        },
      },
      billingAddress: {
        street:
          'D1303, Valmark Orchard Square, Kothnur, Main Road, Next to BMTC Depot JP Nagar',
        city: 'Bangalore',
        state: 'Karnataka',
        country: 'IN',
        specificDetails: {
          stateName: 'Karnataka',
          pinCode: '560076',
        },
      },
      businessActivity: BusinessActivity.Manufacturing,
      directors: [
        {
          name: 'RAGHU VAMSI GONNABATHULA',
          roles: [],
          id: '',
        },
        {
          name: 'AVINASH OGURI',
          roles: [],
          id: '',
        },
        {
          name: 'VENKATA RAMANA NAIDU MARADANA',
          roles: [],
          id: '',
        },
        {
          name: 'NAGARJUNA MALEMPATI',
          roles: [],
          id: '',
        },
      ],
      businessRegistrationType: BusinessRegistrationType.PrivateLimitedCompany,
      contactPerson: '',
      emailAddress: '',
      vendorName: '',
      requestedDate: '',
      profileImagePath: '',
      completed: false,
      role: '',
      createdDate: '',
    },
    flowSteps: {
      steps: [
        {
          details: {},
          stepId: 'select_business',
          state: 'completed',
          action: 'required',
          errors: [],
        },
        {
          details: {},
          stepId: 'director_selection',
          state: 'pending',
          action: 'required',
          errors: [],
        },
        {
          details: {},
          stepId: 'business_compliance_check',
          state: 'pending',
          action: 'required',
          errors: [],
        },
        {
          details: {},
          stepId: 'bank_account_details_info_collection',
          state: 'pending',
          action: 'required',
          errors: [],
        },
        {
          details: {},
          stepId: 'additional_info_collection',
          state: 'pending',
          action: 'required',
          errors: [],
        },
      ],
    },
    context: 'new_business_onboarding',
    onboardingId: '7239e7ac-0d7e-476d-b5b2-e2fa47b37549',
  };

export const kyOnboardingResponseAfterPendingReview: BusinessOnboardingResponse =
  {
    onboardingStatus: 'manual_review',
    business: {
      name: 'review company',
      country: mockCountries[1],
      nonEditables: [BusinessSearchNonEditablesEnum.name],
      address: {
        street: 'ABCDE1234F',
        city: 'ABCDE1234F',
        state: 'ABCDE1234F',
        country: 'IN',
        specificDetails: {
          stateName: 'ABCDE1234F',
          pinCode: 'ABCDE1234F',
        },
      },
      billingAddress: {
        street: 'ABCDE1234F',
        city: 'ABCDE1234F',
        state: 'ABCDE1234F',
        country: 'IN',
        specificDetails: {
          stateName: 'ABCDE1234F',
          pinCode: 'ABCDE1234F',
        },
      },
      businessActivity: BusinessActivity.ResearchAndAnalyticsServices,
      directors: [],
      businessRegistrationType: BusinessRegistrationType.LlpRegistration,
      websiteUrl: 'https://www.promolta.com',
      avgInvoiceSizeInInr: 11111,
      avgNoOfInvoicesPerMonth: 111,
      contactPerson: '',
      emailAddress: '',
      vendorName: '',
      requestedDate: '',
      profileImagePath: '',
      completed: false,
      role: '',
      createdDate: '',
    },
    flowSteps: {
      steps: [],
    },
    context: 'new_business_onboarding',
    onboardingId: '97ec7d24-8886-472a-954b-3ae74a80437b',
  };

export const mockAffiliateVendors: AffiliateVendor[] = [
  // Verified Vendors
  {
    id: 'vendor_001',
    name: 'Western Union',
    email: 'partnerships@westernunion.com',
    verifiedAt: '2024-01-15T10:30:00Z',
    logo: '',
    status: 'verified',
    payoutFeeConfig: {
      sourceCurrency: 'USD',
      destinationCurrency: 'INR',
      fixedPayoutFees: 5.99,
      variablePayoutFeesPercentage: 2.5,
      minimumPayoutAmount: 10.0,
      bankRate: 0,
      fxRate: 83.25,
    },
  },
  {
    id: 'vendor_002',
    name: 'Remitly',
    email: 'business@remitly.com',
    verifiedAt: '2024-02-20T14:45:00Z',
    logo: '',
    status: 'verified',
    payoutFeeConfig: {
      sourceCurrency: 'USD',
      destinationCurrency: 'INR',
      fixedPayoutFees: 3.99,
      variablePayoutFeesPercentage: 1.5,
      minimumPayoutAmount: 1.0,
      bankRate: 0,
      fxRate: 83.15,
    },
  },
  {
    id: 'vendor_003',
    name: 'Wise (formerly TransferWise)',
    email: 'partners@wise.com',
    verifiedAt: '2024-01-08T09:15:00Z',
    logo: '',
    status: 'verified',
    payoutFeeConfig: {
      sourceCurrency: 'USD',
      destinationCurrency: 'INR',
      fixedPayoutFees: 0.0,
      variablePayoutFeesPercentage: 0.75,
      minimumPayoutAmount: 1.0,
      bankRate: 0,
      fxRate: 83.45,
    },
  },
  {
    id: 'vendor_004',
    name: 'MoneyGram',
    email: 'partnerships@moneygram.com',
    verifiedAt: '',
    logo: '',
    status: 'under_verification',
    payoutFeeConfig: {
      sourceCurrency: 'USD',
      destinationCurrency: 'INR',
      fixedPayoutFees: 4.99,
      variablePayoutFeesPercentage: 3.0,
      minimumPayoutAmount: 5.0,
      bankRate: 0,
      fxRate: 82.95,
    },
  },
  {
    id: 'vendor_005',
    name: 'Ria Money Transfer',
    email: 'business@riamoneytransfer.com',
    verifiedAt: '',
    logo: '',
    status: 'under_verification',
    payoutFeeConfig: {
      sourceCurrency: 'USD',
      destinationCurrency: 'INR',
      fixedPayoutFees: 7.5,
      variablePayoutFeesPercentage: 2.0,
      minimumPayoutAmount: 10.0,
      bankRate: 0,
      fxRate: 83.05,
    },
  },
  {
    id: 'vendor_006',
    name: 'Sendwave',
    email: 'partnerships@sendwave.com',
    verifiedAt: '',
    logo: '',
    status: 'kyc_in_progress',
    payoutFeeConfig: {
      sourceCurrency: 'USD',
      destinationCurrency: 'INR',
      fixedPayoutFees: 0.0,
      variablePayoutFeesPercentage: 1.5,
      minimumPayoutAmount: 1.0,
      bankRate: 0,
      fxRate: 83.35,
    },
  },
  {
    id: 'vendor_007',
    name: 'Tempo Money Transfer',
    email: 'business@tempomoneytransfer.com',
    verifiedAt: '',
    logo: '',
    status: 'kyc_in_progress',
    payoutFeeConfig: {
      sourceCurrency: 'USD',
      destinationCurrency: 'INR',
      fixedPayoutFees: 1.5,
      variablePayoutFeesPercentage: 0.65,
      minimumPayoutAmount: 5.0,
      bankRate: 0,
      fxRate: 83.55,
    },
  },

  // Other Status Vendors
  {
    id: 'vendor_008',
    name: 'Xoom (PayPal)',
    email: 'xoom-partners@paypal.com',
    verifiedAt: '',
    logo: '',
    status: 'signed_up',
    payoutFeeConfig: {
      sourceCurrency: 'USD',
      destinationCurrency: 'INR',
      fixedPayoutFees: 4.99,
      variablePayoutFeesPercentage: 2.25,
      minimumPayoutAmount: 10.0,
      bankRate: 0,
      fxRate: 82.85,
    },
  },
  {
    id: 'vendor_009',
    name: 'Remit2India',
    email: 'partnerships@remit2india.com',
    verifiedAt: '',
    logo: '',
    status: 'rejected',
    payoutFeeConfig: {
      sourceCurrency: 'USD',
      destinationCurrency: 'INR',
      fixedPayoutFees: 3.0,
      variablePayoutFeesPercentage: 1.8,
      minimumPayoutAmount: 1.0,
      bankRate: 0,
      fxRate: 83.1,
    },
  },
  {
    id: 'vendor_010',
    name: 'WorldRemit',
    email: 'business@worldremit.com',
    verifiedAt: '',
    logo: '',
    status: 'signed_up',
    payoutFeeConfig: {
      sourceCurrency: 'USD',
      destinationCurrency: 'INR',
      fixedPayoutFees: 3.99,
      variablePayoutFeesPercentage: 1.99,
      minimumPayoutAmount: 1.0,
      bankRate: 0,
      fxRate: 83.2,
    },
  },
  {
    id: 'vendor_011',
    name: 'InstantMoney',
    email: 'partners@instantmoney.com',
    verifiedAt: '',
    logo: '',
    status: 'under_verification',
    payoutFeeConfig: {
      sourceCurrency: 'USD',
      destinationCurrency: 'INR',
      fixedPayoutFees: 6.99,
      variablePayoutFeesPercentage: 2.75,
      minimumPayoutAmount: 15.0,
      bankRate: 0,
      fxRate: 82.75,
    },
  },
  {
    id: 'vendor_012',
    name: 'ExpressMoney',
    email: 'business@expressmoney.com',
    verifiedAt: '',
    logo: '',
    status: 'rejected',
    payoutFeeConfig: {
      sourceCurrency: 'USD',
      destinationCurrency: 'INR',
      fixedPayoutFees: 8.99,
      variablePayoutFeesPercentage: 3.5,
      minimumPayoutAmount: 20.0,
      bankRate: 0,
      fxRate: 82.55,
    },
  },
];

export const mockDeposits: Deposit[] = [
  {
    id: 'dep_001',
    partnerId: 'CB001',
    currency: 'USD',
    amount: 2500.0,
    source: 'PARTNER_VBAN',
    status: 'Classified',
    statementDescriptor: 'Invoice Payment - TechCorp Services',
    b2bProvider: 'Wise',
    paymentMethod: 'ACH',
    receivedAt: '2024-12-15T14:30:00Z',
    formattedAmount: '$2,500.00',
    formattedReceivedDate: 'Dec 15, 2024',
    sourceLabel: 'Partner VBAN',
    paymentMethodLabel: 'ACH Transfer',
  },
  {
    id: 'dep_002',
    partnerId: 'CB002',
    currency: 'USD',
    amount: 1800.5,
    source: 'VENDOR_VBAN',
    status: 'Unclassified',
    statementDescriptor: 'Software License Payment',
    b2bProvider: 'Remitly',
    paymentMethod: 'SWIFT',
    receivedAt: '2024-12-14T09:15:00Z',
    formattedAmount: '$1,800.50',
    formattedReceivedDate: 'Dec 14, 2024',
    sourceLabel: 'Vendor VBAN',
    paymentMethodLabel: 'SWIFT Transfer',
  },
  {
    id: 'dep_003',
    partnerId: 'CB003',
    currency: 'USD',
    amount: 3200.75,
    source: 'PARTNER_VBAN',
    status: 'Classified',
    statementDescriptor: 'Consulting Services Payment',
    b2bProvider: 'Western Union',
    paymentMethod: 'RTP',
    receivedAt: '2024-12-13T16:45:00Z',
    formattedAmount: '$3,200.75',
    formattedReceivedDate: 'Dec 13, 2024',
    sourceLabel: 'Partner VBAN',
    paymentMethodLabel: 'Real-Time Payment',
  },
  {
    id: 'dep_004',
    partnerId: 'CB001',
    currency: 'USD',
    amount: 950.0,
    source: 'VENDOR_VBAN',
    status: 'Unclassified',
    statementDescriptor: 'Monthly Subscription',
    b2bProvider: 'MoneyGram',
    paymentMethod: 'FEDWIRE',
    receivedAt: '2024-12-12T11:20:00Z',
    formattedAmount: '$950.00',
    formattedReceivedDate: 'Dec 12, 2024',
    sourceLabel: 'Vendor VBAN',
    paymentMethodLabel: 'Fedwire',
  },
  {
    id: 'dep_005',
    partnerId: 'CB004',
    currency: 'USD',
    amount: 4750.25,
    source: 'PARTNER_VBAN',
    status: 'Classified',
    statementDescriptor: 'Project Development Payment',
    b2bProvider: 'Wise',
    paymentMethod: 'ACH',
    receivedAt: '2024-12-11T13:10:00Z',
    formattedAmount: '$4,750.25',
    formattedReceivedDate: 'Dec 11, 2024',
    sourceLabel: 'Partner VBAN',
    paymentMethodLabel: 'ACH Transfer',
  },
  {
    id: 'dep_006',
    partnerId: 'CB002',
    currency: 'USD',
    amount: 1200.0,
    source: 'VENDOR_VBAN',
    status: 'Classified',
    statementDescriptor: 'Hardware Purchase',
    b2bProvider: 'Remitly',
    paymentMethod: 'SWIFT',
    receivedAt: '2024-12-10T08:30:00Z',
    formattedAmount: '$1,200.00',
    formattedReceivedDate: 'Dec 10, 2024',
    sourceLabel: 'Vendor VBAN',
    paymentMethodLabel: 'SWIFT Transfer',
  },
  {
    id: 'dep_007',
    partnerId: 'CB003',
    currency: 'USD',
    amount: 6800.0,
    source: 'PARTNER_VBAN',
    status: 'Unclassified',
    statementDescriptor: 'Quarterly Service Fee',
    b2bProvider: 'Western Union',
    paymentMethod: 'RTP',
    receivedAt: '2024-12-09T15:45:00Z',
    formattedAmount: '$6,800.00',
    formattedReceivedDate: 'Dec 9, 2024',
    sourceLabel: 'Partner VBAN',
    paymentMethodLabel: 'Real-Time Payment',
  },
  {
    id: 'dep_008',
    partnerId: 'CB005',
    currency: 'USD',
    amount: 320.5,
    source: 'VENDOR_VBAN',
    status: 'Classified',
    statementDescriptor: 'Maintenance Fee',
    b2bProvider: 'MoneyGram',
    paymentMethod: 'ACH',
    receivedAt: '2024-12-08T12:00:00Z',
    formattedAmount: '$320.50',
    formattedReceivedDate: 'Dec 8, 2024',
    sourceLabel: 'Vendor VBAN',
    paymentMethodLabel: 'ACH Transfer',
  },
  {
    id: 'dep_009',
    partnerId: 'CB001',
    currency: 'USD',
    amount: 5500.75,
    source: 'PARTNER_VBAN',
    status: 'Classified',
    statementDescriptor: 'Annual License Renewal',
    b2bProvider: 'Wise',
    paymentMethod: 'FEDWIRE',
    receivedAt: '2024-12-07T10:15:00Z',
    formattedAmount: '$5,500.75',
    formattedReceivedDate: 'Dec 7, 2024',
    sourceLabel: 'Partner VBAN',
    paymentMethodLabel: 'Fedwire',
  },
  {
    id: 'dep_010',
    partnerId: 'CB006',
    currency: 'USD',
    amount: 890.25,
    source: 'VENDOR_VBAN',
    status: 'Unclassified',
    statementDescriptor: 'Training Services',
    b2bProvider: 'Remitly',
    paymentMethod: 'SWIFT',
    receivedAt: '2024-12-06T14:20:00Z',
    formattedAmount: '$890.25',
    formattedReceivedDate: 'Dec 6, 2024',
    sourceLabel: 'Vendor VBAN',
    paymentMethodLabel: 'SWIFT Transfer',
  },
];

// export const
